// import React, { useState, useEffect, useRef } from "react";
// import {
//   X,
//   MapPin,
//   Clock,
//   Navigation,
//   Layers,
//   AlertCircle,
//   RefreshCw,
//   Activity,
//   Play,
//   Pause,
//   Search,
//   RotateCcw,
//   X as XIcon,
// } from "lucide-react";
// import { BASE_URL } from "../config";
// import { getAuthHeaders } from "../services/useAuth";
// import { formatDate } from "../utils/formatDate";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import homeMarker from "../images/homeMarker.png";
// import { loadGoogleMaps } from "../utils/loadGoogleMaps";
// import { formatTimeTo12Hour } from "../utils/formatTime";
// import formatActivityType from "../Admin/ActivityEnum";

// import punchInIcon from "../images/punch_in.png";
// import punchExitIcon from "../images/punch_exit.png";

// const geocodeAddress = (geocoder, address) => {
//   return new Promise((resolve, reject) => {
//     try {
//       geocoder.geocode({ address }, (results, status) => {
//         if (status === "OK" && results && results[0]) {
//           const loc = results[0].geometry.location;
//           resolve({ lat: loc.lat(), lng: loc.lng(), raw: results[0] });
//         } else {
//           reject(new Error(`Geocode failed: ${status}`));
//         }
//       });
//     } catch (err) {
//       reject(err);
//     }
//   });
// };

// const EmployeeMapTracker = ({
//   onClose,
//   employeeId: propEmployeeId,
//   trackDate: propDate,
//   employeeName,
//   isModal = false,
//   context = "single",
//   visitId: propVisitId,
//   residenceAddress,
//   specificPunchTime = null,
//   firstCallTime = "",
//   lastCallTime = "",
//   morningPunchTime = "",
//   eveningPunchTime = "",
//   routeName = "",
//   latestLocation = "",
//   gpsStop = "",
//   locationCount = 0,
//   gpsStopIdleTime = "",
//   visits = 0,
//   pob = 0,
// }) => {
//   const { locId } = useParams();
//   const { search } = useLocation();
//   const navigate = useNavigate();
//   const qs = new URLSearchParams(search);
//   const [searchQuery, setSearchQuery] = useState("");
//   const searchInputRef = useRef(null);
//   const autocompleteRef = useRef(null);
//   const [searchReady, setSearchReady] = useState(false);
//   const employeeIdParam =
//     qs.get("employee_id") ||
//     qs.get("employeeId") ||
//     qs.get("emp_id") ||
//     qs.get("empId") ||
//     "";
//   const visitId =
//     propVisitId ||
//     qs.get("visit_id") ||
//     qs.get("visitId") ||
//     "";
//   const dateParam =
//     qs.get("track_date") ||
//     qs.get("trackDate") ||
//     qs.get("date") ||
//     qs.get("working_date") ||
//     "";

//   const employeeId =
//     propEmployeeId ||
//     employeeIdParam ||
//     sessionStorage.getItem("location_history_employee_id") ||
//     "";
//   const date =
//     propDate ||
//     dateParam ||
//     sessionStorage.getItem("location_history_track_date") ||
//     "";

//   const [map, setMap] = useState(null);
//   const [mapType, setMapType] = useState("roadmap");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [locationData, setLocationData] = useState([]);
//   const [compareLocations, setCompareLocations] = useState([]);
//   const [fullDayLocations, setFullDayLocations] = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [animationIndex, setAnimationIndex] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [googleLoaded, setGoogleLoaded] = useState(false);
//   const [linearDistance, setLinearDistance] = useState(null);
//   const mapRef = useRef(null);
//   const animationRef = useRef(null);
//   const cacheRef = useRef(new Map());
//   const USE_SESSION_FALLBACK = true;
//   const [totalDistance, setTotalDistance] = useState(0);

//   const mapInstanceRef = useRef(null);
//   const markersRef = useRef([]);
//   const polylinesRef = useRef([]);
//   const animationMarkerRef = useRef(null);
//   const homeMarkerRef = useRef(null);
//   const cancelledRef = useRef(false);

//   const isGoogleReady = () =>
//     typeof window !== "undefined" &&
//     window.google &&
//     window.google.maps &&
//     typeof window.google.maps.Map === "function";

//   const normalizeDateForApi = (dateStr) => {
//     if (!dateStr) return "";
//     if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
//     const d = new Date(dateStr);
//     const yyyy = d.getFullYear();
//     const mm = String(d.getMonth() + 1).padStart(2, "0");
//     const dd = String(d.getDate()).padStart(2, "0");
//     return `${yyyy}-${mm}-${dd}`;
//   };

//   const getCompareRole = (employeeType) => {
//     if (!employeeType) return "JR";
//     const t = String(employeeType).toLowerCase();
//     if (t === "individual") return "IND";
//     if (t === "sr" || t === "manager") return "SR";
//     if (t === "jr") return "JR";
//     return "JR";
//   };

//   const buildVisitMarkerSVG = ({ time, name, bgColor }) => `
// <svg width="160" height="60" xmlns="http://www.w3.org/2000/svg">
//   <rect x="10" y="5" rx="6" ry="6" width="140" height="22" fill="#111827"/>
//   <text x="80" y="21" text-anchor="middle"
//         font-size="12" font-weight="700" fill="#ffffff" font-family="Arial">
//     ${time}
//   </text>
//   <rect x="10" y="30" rx="6" ry="6" width="140" height="22" fill="${bgColor}"/>
//   <text x="80" y="46" text-anchor="middle"
//         font-size="11" font-weight="600" fill="#ffffff" font-family="Arial">
//     ${name}
//   </text>
// </svg>`;

//   const buildCompareMarkerSVG = ({ role, time, bg }) => `
// <svg width="90" height="58" xmlns="http://www.w3.org/2000/svg">
//   <rect x="10" y="2" rx="6" ry="6" width="70" height="22" fill="${bg}" />
//   <text x="45" y="18" text-anchor="middle"
//         font-size="12" font-weight="700" fill="#fff" font-family="Arial">
//     ${role}
//   </text>
//   <rect x="12" y="28" rx="6" ry="6" width="66" height="22" fill="#111827" />
//   <text x="45" y="44" text-anchor="middle"
//         font-size="11" font-weight="600" fill="#fff" font-family="Arial">
//     ${time}
//   </text>
// </svg>`;

//   // ✅ UPDATED: includes add_expense_visit
//   const getActivityColor = (activityType) => {
//     const activity = (activityType || "").toLowerCase();
//     if (activity.includes("employee_address") || activity === "employee_address") return "#f59e0b";
//     if (activity.includes("punch_in") || activity.includes("morning_punch") || activity === "punched") return "#10b981";
//     if (activity.includes("punch_out") || activity.includes("evening_punch") || activity.includes("exit")) return "#ef4444";
//     if (activity.includes("add_doctor_visit")) return "#8b5cf6";
//     if (activity.includes("add_chemist_visit")) return "#ec4899";
//     if (activity.includes("add_stockist_visit")) return "#f97316";
//     if (activity.includes("last_call")) return "#06b6d4";
//     if (activity.includes("add_expense_visit")) return "#14b8a6"; // ✅ teal
//     if (activity.includes("visit") || activity.includes("call")) return "#3b82f6";
//     return "#6b7280";
//   };

//   // ✅ UPDATED: includes add_expense_visit
//   const getActivityLabel = (activityType) => {
//     const activity = (activityType || "").toLowerCase();
//     if (activity.includes("employee_address") || activity === "employee_address") return "Home Address";
//     if (activity.includes("punch_in") || activity.includes("morning_punch") || activity === "punched") return "Punch In";
//     if (activity.includes("punch_out") || activity.includes("evening_punch")) return "Punch Out";
//     if (activity.includes("exit")) return "Exit";
//     if (activity.includes("add_doctor_visit")) return "Doctor Visit";
//     if (activity.includes("add_chemist_visit")) return "Chemist Visit";
//     if (activity.includes("add_stockist_visit")) return "Stockist Visit";
//     if (activity.includes("last_call")) return "Last Call";
//     if (activity.includes("add_expense_visit")) return "Expense Visit"; // ✅
//     if (activity.includes("visit")) return "Visit";
//     if (activity.includes("call_stop")) return "Call Stop";
//     if (activity.includes("call")) return "Call";
//     return "Activity";
//   };

//   // ✅ UPDATED: includes add_expense_visit
//   const getActivityIcon = (activityType) => {
//     const activity = (activityType || "").toLowerCase();
//     if (activity.includes("employee_address") || activity === "employee_address") return "🏠";
//     if (activity.includes("punch_in") || activity.includes("morning_punch") || activity === "punched") return "🚀";
//     if (activity.includes("punch_out") || activity.includes("evening_punch")) return "🏁";
//     if (activity.includes("add_doctor_visit")) return "🏥";
//     if (activity.includes("add_chemist_visit")) return "💊";
//     if (activity.includes("add_stockist_visit")) return "📦";
//     if (activity.includes("last_call")) return "📞";
//     if (activity.includes("add_expense_visit")) return "🧾"; // ✅
//     if (activity.includes("visit")) return "🏢";
//     if (activity.includes("call_stop")) return "📵";
//     if (activity.includes("call")) return "📞";
//     return "📍";
//   };

//   const getActivityMarkerIcon = (activityType, scale = 11) => {
//     const activity = (activityType || "").toLowerCase().trim();

//     const isLarge = scale >= 14;
//     const size = isLarge ? 52 : 42;
//     const half = size / 2;
//     const iconSize = isLarge ? 18 : 15;
//     const iconOffset = isLarge ? 7 : 6;

//     const makePin = (bgColor, borderColor, iconPaths) => ({
//       url:
//         "data:image/svg+xml;charset=UTF-8," +
//         encodeURIComponent(`
//         <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size + 12}" viewBox="0 0 ${size} ${size + 12}">
//           <ellipse cx="${half}" cy="${size + 10}" rx="${half * 0.45}" ry="2.5" fill="rgba(0,0,0,0.18)"/>
//           <path d="M${half},${size + 5} C${half},${size + 5} 2,${half + 10} 2,${half} A${half - 2},${half - 2} 0 1,1 ${size - 2},${half} C${size - 2},${half + 10} ${half},${size + 5} ${half},${size + 5} Z"
//                 fill="${bgColor}" stroke="${borderColor}" stroke-width="1.5"/>
//           <circle cx="${half}" cy="${half}" r="${half * 0.54}" fill="white" opacity="0.97"/>
//           <g transform="translate(${half - iconSize / 2}, ${half - iconSize / 2}) scale(${iconSize / 24})">
//             ${iconPaths}
//           </g>
//         </svg>
//       `),
//       scaledSize: new window.google.maps.Size(size, size + 12),
//       anchor: new window.google.maps.Point(half, size + 12),
//     });

//     // ── Home / Employee Address ──
//     if (activity.includes("employee_address"))
//       return makePin(
//         "#f59e0b",
//         "#d97706",
//         `
//       <path d="M3 12L12 3l9 9" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
//       <path d="M9 21V12h6v9" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
//       <rect x="3" y="12" width="18" height="9" rx="1" stroke="#f59e0b" stroke-width="2" fill="none"/>
//     `,
//       );

//     // ── Morning Punch In ──
//     if (
//       activity.includes("punch_in") ||
//       activity.includes("morning_punch") ||
//       activity === "punched"
//     )
//       return makePin(
//         "#10b981",
//         "#059669",
//         `
//       <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
//       <polyline points="10 17 15 12 10 7" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
//       <line x1="15" y1="12" x2="3" y2="12" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
//     `,
//       );

//     // ── Evening Punch Out / Exit ──
//     if (
//       activity.includes("punch_out") ||
//       activity.includes("evening_punch") ||
//       activity.includes("exit")
//     )
//       return makePin(
//         "#ef4444",
//         "#dc2626",
//         `
//       <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
//       <polyline points="16 17 21 12 16 7" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
//       <line x1="21" y1="12" x2="9" y2="12" stroke="#ef4444" stroke-width="2" stroke-linecap="round"/>
//     `,
//       );

//     // ── Doctor Visit ──
//     if (activity.includes("add_doctor_visit") || activity.includes("doctor"))
//       return makePin(
//         "#8b5cf6",
//         "#7c3aed",
//         `
//       <path d="M12 2a5 5 0 0 1 5 5v3a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5z" stroke="#8b5cf6" stroke-width="2" fill="none"/>
//       <path d="M12 15v2" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round"/>
//       <path d="M7 17a5 5 0 0 0 10 0" stroke="#8b5cf6" stroke-width="2" fill="none" stroke-linecap="round"/>
//       <circle cx="17" cy="17" r="2" fill="#8b5cf6"/>
//       <line x1="10" y1="7" x2="14" y2="7" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round"/>
//       <line x1="12" y1="5" x2="12" y2="9" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round"/>
//     `,
//       );

//     // ── Chemist Visit ──
//     if (activity.includes("chemist"))
//       return makePin(
//         "#ec4899",
//         "#db2777",
//         `
//     <g transform="rotate(-35 12 12)">
//       <rect x="5" y="9" width="14" height="6" rx="3" fill="#ec4899"/>
//       <rect x="12" y="9" width="7" height="6" rx="3" fill="white"/>
//     </g>
//   `,
//       );

//     // ── Stockist Visit ──
//     if (activity.includes("add_stockist_visit"))
//       return makePin(
//         "#f97316",
//         "#ea580c",
//         `
//       <path d="M21 8L12 3 3 8v8l9 5 9-5V8z" stroke="#f97316" stroke-width="2" stroke-linejoin="round" fill="none"/>
//       <polyline points="3 8 12 13 21 8" stroke="#f97316" stroke-width="2" stroke-linejoin="round" fill="none"/>
//       <line x1="12" y1="13" x2="12" y2="22" stroke="#f97316" stroke-width="2"/>
//     `,
//       );

//     // ── Last Call ──
//     if (activity.includes("last_call"))
//       return makePin(
//         "#06b6d4",
//         "#0891b2",
//         `
//       <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.37 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.12 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="#06b6d4" stroke-width="2" fill="none"/>
//       <path d="M14.5 2a9.5 9.5 0 0 1 7.5 7.5" stroke="#06b6d4" stroke-width="2" stroke-linecap="round" fill="none"/>
//       <path d="M14.5 6A5.5 5.5 0 0 1 18 9.5" stroke="#06b6d4" stroke-width="2" stroke-linecap="round" fill="none"/>
//     `,
//       );

//     // ✅ NEW: Expense Visit — receipt icon (MUST be before generic visit)
//     if (activity.includes("add_expense_visit"))
//       return makePin(
//         "#14b8a6",
//         "#0d9488",
//         `
//       <rect x="5" y="3" width="14" height="18" rx="2" stroke="#14b8a6" stroke-width="2" fill="none"/>
//       <line x1="9" y1="8"  x2="15" y2="8"  stroke="#14b8a6" stroke-width="1.5" stroke-linecap="round"/>
//       <line x1="9" y1="12" x2="15" y2="12" stroke="#14b8a6" stroke-width="1.5" stroke-linecap="round"/>
//       <line x1="9" y1="16" x2="12" y2="16" stroke="#14b8a6" stroke-width="1.5" stroke-linecap="round"/>
//     `,
//       );

//     // ── Generic Visit ──
//     if (activity.includes("visit"))
//       return makePin(
//         "#3b82f6",
//         "#2563eb",
//         `
//       <rect x="3" y="3" width="18" height="18" rx="2" stroke="#3b82f6" stroke-width="2" fill="none"/>
//       <line x1="9" y1="3" x2="9" y2="21" stroke="#3b82f6" stroke-width="2"/>
//       <line x1="15" y1="3" x2="15" y2="21" stroke="#3b82f6" stroke-width="2"/>
//       <line x1="3" y1="9" x2="21" y2="9" stroke="#3b82f6" stroke-width="2"/>
//       <line x1="3" y1="15" x2="21" y2="15" stroke="#3b82f6" stroke-width="2"/>
//     `,
//       );

//     // ── Call Stop ──
//     if (activity.includes("call_stop"))
//       return makePin(
//         "#6b7280",
//         "#4b5563",
//         `
//       <line x1="1" y1="1" x2="23" y2="23" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/>
//       <path d="M16.5 16.5l3.77 3.77a2 2 0 0 0 2.73-2.73l-3.77-3.77A9 9 0 0 0 4.73 4.73L1 1" stroke="#6b7280" stroke-width="2" fill="none" stroke-linecap="round"/>
//     `,
//       );

//     // ── Generic Call ──
//     if (activity.includes("call"))
//       return makePin(
//         "#3b82f6",
//         "#2563eb",
//         `
//       <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.37 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.12 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="#3b82f6" stroke-width="2" fill="none"/>
//     `,
//       );

//     // ── Default ──
//     return makePin(
//       "#6b7280",
//       "#4b5563",
//       `
//     <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="#6b7280" stroke-width="2" fill="none"/>
//     <circle cx="12" cy="9" r="2.5" fill="#6b7280"/>
//   `,
//     );
//   };

//   const isTravelActivity = (activityType) => {
//     const activity = (activityType || "").toLowerCase();
//     return (
//       activity === "travel" ||
//       activity === "" ||
//       activity === "null" ||
//       activity === "unknown" ||
//       !activityType
//     );
//   };

//   const clearMapElements = () => {
//     markersRef.current.forEach((marker) => {
//       try {
//         if (marker && marker.setMap) marker.setMap(null);
//       } catch (_) { }
//     });
//     markersRef.current = [];

//     polylinesRef.current.forEach((p) => {
//       try {
//         if (p && p.setMap) p.setMap(null);
//       } catch (_) { }
//     });
//     polylinesRef.current = [];

//     if (animationMarkerRef.current) {
//       try {
//         animationMarkerRef.current.setMap(null);
//       } catch (_) { }
//       animationMarkerRef.current = null;
//     }

//     if (homeMarkerRef.current) {
//       try {
//         homeMarkerRef.current.setMap(null);
//       } catch (_) { }
//       homeMarkerRef.current = null;
//     }
//   };

//   // ─── FETCH COMPARE LOCATIONS — untouched ───
//   const fetchCompareLocations = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const formattedDate = normalizeDateForApi(propDate);
//       const url = `${BASE_URL}/api/employee/${employeeId}/compare-locations?track_date=${formattedDate}`;
//       console.log("🔍 Fetching compare locations:", url);
//       const response = await fetch(url, { headers: getAuthHeaders() });
//       if (!response.ok)
//         throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       console.log("✅ Compare locations received:", data);
//       if (!cancelledRef.current)
//         setCompareLocations(Array.isArray(data) ? data : []);
//     } catch (err) {
//       console.error("❌ Compare locations error:", err);
//       if (!cancelledRef.current) {
//         setError(err.message || "Failed to fetch compare locations");
//         setCompareLocations([]);
//       }
//     } finally {
//       if (!cancelledRef.current) setLoading(false);
//     }
//   };

//   // ─── FETCH REGULAR LOCATIONS — only setLocationData logic changed for "expense" ───
//   const fetchLocationData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const formattedDate = date
//         ? new Date(date).toISOString().split("T")[0]
//         : "";
//       const url = `${BASE_URL}/api/employee/${employeeId}/locations${formattedDate ? `?track_date=${encodeURIComponent(formattedDate)}` : ""
//         }${visitId ? `&visit_id=${encodeURIComponent(visitId)}` : ""}`;
//       console.log("🔍 Fetching regular locations:", url);
//       const response = await fetch(url, { headers: getAuthHeaders() });
//       if (!response.ok)
//         throw new Error(`HTTP error! status: ${response.status}`);
//       const jsonData = await response.json();
//       console.log("✅ Regular locations received:", jsonData);

//       const sortedData = Array.isArray(jsonData)
//         ? jsonData.sort((a, b) => {
//           const timeA = new Date(
//             a.mobile_time || a.server_time || 0,
//           ).getTime();
//           const timeB = new Date(
//             b.mobile_time || b.server_time || 0,
//           ).getTime();
//           return timeA - timeB;
//         })
//         : [];
//       setFullDayLocations(sortedData);

//       const filtered = sortedData.filter((loc) => {
//         const activity = (loc.activity_type || "").toLowerCase();
//         return !isTravelActivity(activity);
//       });

//       if (!cancelledRef.current) {
//         // ─── punch contexts — unchanged ───
//         if (
//           (context === "morningPunch" || context === "eveningPunch") &&
//           specificPunchTime
//         ) {
//           const targetTime = String(specificPunchTime).substring(0, 16);
//           const matched = sortedData.reduce((closest, loc) => {
//             const locTime = String(
//               loc.mobile_time || loc.server_time || "",
//             ).substring(0, 16);
//             if (!closest) return loc;
//             const closestTime = String(
//               closest.mobile_time || closest.server_time || "",
//             ).substring(0, 16);
//             return Math.abs(locTime.localeCompare(targetTime)) <
//               Math.abs(closestTime.localeCompare(targetTime))
//               ? loc
//               : closest;
//           }, null);
//           setLocationData(matched ? [matched] : sortedData.slice(0, 1));
//           return;
//         }

//         if (locId) {
//           const byId = filtered.filter(
//             (l) =>
//               String(l.id) === String(locId) ||
//               String(l.location_id) === String(locId) ||
//               String(l.locationId) === String(locId),
//           );
//           setLocationData(byId.length ? byId : filtered);
//         } else if (context === "expense") {
//           // ✅ EXPENSE: only show add_expense_visit points, hide everything else
//           const expenseOnly = sortedData.filter((loc) =>
//             (loc.activity_type || "").toLowerCase().includes("add_expense_visit")
//           );
//           setLocationData(expenseOnly);
//         } else {
//           setLocationData(sortedData);
//           if (sortedData.length > 0) {
//            setTotalDistance(
//             sortedData[sortedData.length - 1]?.km_covered || 0
//           );
//           }
//         }
//       }
//     } catch (err) {
//       console.error("❌ Error fetching location data:", err);
//       if (!cancelledRef.current) {
//         setError(err.message || "Failed to fetch location data");
//         setLocationData([]);
//       }
//     } finally {
//       if (!cancelledRef.current) setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!searchReady || !searchInputRef.current || !mapInstanceRef.current)
//       return;
//     if (!window.google?.maps?.places?.Autocomplete) {
//       console.warn(
//         "⚠️ Google Places library not loaded — add &libraries=places to your Maps URL",
//       );
//       return;
//     }

//     if (autocompleteRef.current) {
//       window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
//       autocompleteRef.current = null;
//     }

//     const autocomplete = new window.google.maps.places.Autocomplete(
//       searchInputRef.current,
//       { fields: ["geometry", "name", "formatted_address"] },
//     );

//     autocomplete.bindTo("bounds", mapInstanceRef.current);

//     autocomplete.addListener("place_changed", () => {
//       const place = autocomplete.getPlace();
//       if (!place?.geometry?.location) return;

//       const loc = place.geometry.location;

//       if (place.geometry.viewport) {
//         mapInstanceRef.current.fitBounds(place.geometry.viewport);
//       } else {
//         mapInstanceRef.current.setCenter(loc);
//         mapInstanceRef.current.setZoom(15);
//       }

//       const searchMarker = new window.google.maps.Marker({
//         position: loc,
//         map: mapInstanceRef.current,
//         title: place.name,
//         icon: {
//           url:
//             "data:image/svg+xml;charset=UTF-8," +
//             encodeURIComponent(`
//     <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50">
//       <ellipse cx="20" cy="48" rx="8" ry="3" fill="rgba(0,0,0,0.25)"/>
//       <path d="M20 2 C10 2 2 10 2 20 C2 32 20 46 20 46 C20 46 38 32 38 20 C38 10 30 2 20 2 Z"
//             fill="#f59e0b" stroke="#ffffff" stroke-width="2"/>
//       <circle cx="18" cy="18" r="7" fill="none" stroke="#ffffff" stroke-width="2.5"/>
//       <line x1="23" y1="23" x2="28" y2="28" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"/>
//     </svg>
//   `),
//           scaledSize: new window.google.maps.Size(40, 50),
//           anchor: new window.google.maps.Point(20, 50),
//         },
//         zIndex: 9999,
//         optimized: false,
//       });

//       const infoWindow = new window.google.maps.InfoWindow({
//         content: `
//         <div style="padding:10px;font-family:sans-serif;min-width:200px;">
//           <div style="font-weight:700;font-size:14px;color:#f59e0b;margin-bottom:4px;">
//             🔍 ${place.name}
//           </div>
//           <div style="font-size:12px;color:#6b7280;">${place.formatted_address || ""}</div>
//         </div>
//       `,
//       });

//       infoWindow.open(mapInstanceRef.current, searchMarker);
//       searchMarker.addListener("click", () =>
//         infoWindow.open(mapInstanceRef.current, searchMarker),
//       );
//       setTimeout(() => {
//         try {
//           searchMarker.setMap(null);
//         } catch (_) { }
//       }, 30000);
//     });

//     autocompleteRef.current = autocomplete;
//   }, [searchReady, map]);

//   useEffect(() => {
//     cancelledRef.current = false;
//     setLinearDistance(null);

//     const setup = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
//         if (!apiKey)
//           throw new Error(
//             "Missing REACT_APP_GOOGLE_MAPS_API_KEY environment variable",
//           );
//         await loadGoogleMaps(apiKey);
//         if (cancelledRef.current) return;
//         setGoogleLoaded(true);

//         if (context === "compare") {
//           await fetchCompareLocations();
//         } else if (context === "homeOnly") {
//           console.log("🏠 Home only mode — skipping location API");
//         } else {
//           await fetchLocationData();
//         }
//       } catch (err) {
//         console.error("Setup error:", err);
//         if (!cancelledRef.current)
//           setError("Failed to load maps: " + (err.message || err));
//       } finally {
//         if (!cancelledRef.current) setLoading(false);
//       }
//     };

//     setup();

//     return () => {
//       cancelledRef.current = true;
//       clearMapElements();
//       if (animationRef.current) clearTimeout(animationRef.current);
//     };
//   }, [employeeId, date, locId, context]);

//   // ─── Compare mode effect — untouched ───
//   useEffect(() => {
//     if (
//       context !== "compare" ||
//       !compareLocations ||
//       compareLocations.length === 0 ||
//       !isGoogleReady() ||
//       !mapRef.current
//     )
//       return;

//     clearMapElements();

//     const googleMap = new window.google.maps.Map(mapRef.current, {
//       zoom: 14,
//       mapTypeId: mapType,
//       mapTypeControl: false,
//       streetViewControl: false,
//       fullscreenControl: true,
//     });

//     mapInstanceRef.current = googleMap;
//     setMap(googleMap);

//     const bounds = new window.google.maps.LatLngBounds();

//     const placeMarker = (point) => {
//       const lat = Number(point.latitude);
//       const lng = Number(point.longitude);
//       if (isNaN(lat) || isNaN(lng)) return;

//       const position = { lat, lng };
//       bounds.extend(position);

//       const role = getCompareRole(point.employee_type);
//       const time = formatTimeTo12Hour(
//         point.mobile_time || point.server_time
//       );

//       const svg = buildCompareMarkerSVG({
//         role,
//         time,
//         bg: role === "SR" ? "#2563eb" : role === "IND" ? "#10b981" : "#dc2626",
//       });

//       const marker = new window.google.maps.Marker({
//         draggable: true,
//         position,
//         map: googleMap,
//         icon: {
//           url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
//           scaledSize: new window.google.maps.Size(90, 58),
//           anchor: new window.google.maps.Point(45, 58),
//         },
//         optimized: false,
//       });
//       markersRef.current.push(marker);
//     };

//     compareLocations.forEach(placeMarker);

//     if (!bounds.isEmpty()) googleMap.fitBounds(bounds);
//   }, [context, compareLocations, mapType]);

//   // ─── homeOnly effect — untouched ───
//   useEffect(() => {
//     if (
//       context !== "homeOnly" ||
//       !googleLoaded ||
//       !isGoogleReady() ||
//       !mapRef.current ||
//       !residenceAddress
//     )
//       return;

//     clearMapElements();

//     const googleMap = new window.google.maps.Map(mapRef.current, {
//       zoom: 15,
//       mapTypeId: mapType,
//       mapTypeControl: false,
//       streetViewControl: false,
//       fullscreenControl: true,
//     });

//     mapInstanceRef.current = googleMap;
//     setMap(googleMap);

//     const geocoder = new window.google.maps.Geocoder();

//     geocoder.geocode({ address: residenceAddress }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const loc = results[0].geometry.location;
//         googleMap.setCenter(loc);

//         const marker = new window.google.maps.Marker({
//           draggable: true,
//           position: loc,
//           map: googleMap,
//           title: "Home Address",
//           icon: {
//             url: homeMarker,
//             scaledSize: new window.google.maps.Size(36, 36),
//             anchor: new window.google.maps.Point(18, 36),
//           },
//         });
//         homeMarkerRef.current = marker;

//         const infoWindow = new window.google.maps.InfoWindow({
//           content: `
//             <div style="padding:10px;font-family:sans-serif;">
//               <strong>Home Address</strong>
//               <div style="margin-top:6px;font-size:13px;">${residenceAddress}</div>
//             </div>
//           `,
//         });

//         marker.addListener("click", () => infoWindow.open(googleMap, marker));
//       } else {
//         console.warn("Geocode failed:", status);
//       }
//     });
//   }, [context, mapType, residenceAddress, googleLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

//   const drawRoutes = async (locations, googleMap) => {
//     if (!window.google?.maps?.DirectionsService) return;
//     const directionsService = new window.google.maps.DirectionsService();
//     const CHUNK_SIZE = 24;

//     for (
//       let chunkStart = 0;
//       chunkStart < locations.length - 1;
//       chunkStart += CHUNK_SIZE
//     ) {
//       const chunkEnd = Math.min(chunkStart + CHUNK_SIZE, locations.length - 1);
//       const chunkLocations = locations.slice(chunkStart, chunkEnd + 1);
//       if (chunkLocations.length < 2) continue;

//       const origin = {
//         lat: Number(chunkLocations[0].latitude),
//         lng: Number(chunkLocations[0].longitude),
//       };
//       const destination = {
//         lat: Number(chunkLocations[chunkLocations.length - 1].latitude),
//         lng: Number(chunkLocations[chunkLocations.length - 1].longitude),
//       };
//       const waypoints = chunkLocations.slice(1, -1).map((loc) => ({
//         location: { lat: Number(loc.latitude), lng: Number(loc.longitude) },
//         stopover: false,
//       }));

//       try {
//         await new Promise((resolve) => {
//           directionsService.route(
//             {
//               origin,
//               destination,
//               waypoints,
//               travelMode: window.google.maps.TravelMode.DRIVING,
//               optimizeWaypoints: false,
//             },
//             (result, status) => {
//               if (status === "OK" && result) {
//                 const polyline = new window.google.maps.Polyline({
//                   path: result.routes[0].overview_path,
//                   geodesic: true,
//                   // strokeColor: "#2563eb",
//                   strokeColor: "#ef4444",
//                   strokeOpacity: 0.85,
//                   strokeWeight: 4,
//                   zIndex: 60,
//                 });
//                 polyline.setMap(googleMap);
//                 polylinesRef.current.push(polyline);
//               } else {
//                 for (let i = 0; i < chunkLocations.length - 1; i++) {
//                   const lat1 = Number(chunkLocations[i].latitude);
//                   const lng1 = Number(chunkLocations[i].longitude);
//                   const lat2 = Number(chunkLocations[i + 1].latitude);
//                   const lng2 = Number(chunkLocations[i + 1].longitude);
//                   if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2))
//                     continue;
//                   const line = new window.google.maps.Polyline({
//                     path: [
//                       { lat: lat1, lng: lng1 },
//                       { lat: lat2, lng: lng2 },
//                     ],
//                     geodesic: true,
//                     // strokeColor: "#2563eb",
//                     strokeColor: "#ef4444",
//                     strokeOpacity: 0.6,
//                     strokeWeight: 3,
//                     zIndex: 40,
//                   });
//                   line.setMap(googleMap);
//                   polylinesRef.current.push(line);
//                 }
//               }
//               resolve();
//             },
//           );
//         });
//         await new Promise((r) => setTimeout(r, 150));
//       } catch (err) {
//         console.warn("Route chunk error:", err);
//       }
//     }
//   };

//   // ─── EFFECT 4: Single mode map ───
//   // ✅ "expense" context is now allowed through (not in the skip list)
//   useEffect(() => {
//     if (
//       context === "compare" ||
//       context === "homeOnly" ||
//       context === "morningPunch" ||
//       context === "eveningPunch" ||
//       !locationData ||
//       locationData.length === 0 ||
//       !googleLoaded ||
//       !isGoogleReady() ||
//       !mapRef.current
//     )
//       return;

//     console.log(
//       "🗺️ Rendering single location map with",
//       locationData.length,
//       "locations",
//     );

//     clearMapElements();

//     try {
//       const firstLocation = locationData[0];
//       const centerLat = Number(firstLocation.latitude);
//       const centerLng = Number(firstLocation.longitude);

//       if (isNaN(centerLat) || isNaN(centerLng))
//         throw new Error("Invalid coordinates in first location");

//       const googleMap = new window.google.maps.Map(mapRef.current, {
//         zoom: 13,
//         center: { lat: centerLat, lng: centerLng },
//         mapTypeId: mapType,
//         mapTypeControl: false,
//         streetViewControl: false,
//         fullscreenControl: true,
//         zoomControl: true,
//       });

//       mapInstanceRef.current = googleMap;
//       setMap(googleMap);

//       const bounds = new window.google.maps.LatLngBounds();

//       locationData.forEach((location, index) => {
//         const lat = Number(location.latitude);
//         const lng = Number(location.longitude);
//         if (isNaN(lat) || isNaN(lng)) return;

//         const position = { lat, lng };
//         bounds.extend(position);

//         const activity = (location.activity_type || "").toLowerCase();
//         const isTravel = isTravelActivity(activity);
//         const activityColor = getActivityColor(activity);
//         const activityLabel = getActivityLabel(activity);

//         const isFirstPoint = index === 0;
//         const isLastPoint = index === locationData.length - 1;
//         const scale = isFirstPoint || isLastPoint ? 21 : 17;

//         const marker = new window.google.maps.Marker({
//           draggable: true,
//           position,
//           map: googleMap,
//           icon: isTravel
//             ? {
//               path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
//               scale: 5,
//               fillColor: "#dceb0e",
//               fillOpacity: 1,
//               strokeColor: "#374151",
//               strokeWeight: 1,
//               rotation: location.heading || 0,
//             }
//             : getActivityMarkerIcon(location.activity_type, scale),
//           label: isTravel
//             ? {
//               text: formatTimeTo12Hour(location.server_time),
//               color: "#111827",
//               fontSize: "11px",
//               fontWeight: "600",
//               className: "map-label",
//             }
//             : undefined,
//           zIndex: 2000,
//           optimized: false,
//         });

//         const infoContent = `
//   <div style="padding:14px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;max-width:320px;">
//     <div style="font-weight:700;font-size:17px;color:${activityColor};margin-bottom:10px;display:flex;align-items:center;gap:8px;">
//       ${getActivityIcon(activity)} ${activityLabel}
//     </div>
//     <div style="font-size:14px;color:#1f2937;line-height:1.7;">

//       <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//         <strong style="color:#6b7280;">Date:</strong>
//         <span style="font-weight:500;">${formatDate(location.mobile_time)}</span>
//       </div>

//       ${location.doctor_name ? `
//         <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//           <strong style="color:#6b7280;">🏥 Doctor:</strong>
//           <span style="font-weight:600;color:#8b5cf6;">${location.doctor_name}</span>
//         </div>` : ""}

//       ${location.call_name && !location.doctor_name ? `
//         <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//           <strong style="color:#6b7280;">${activity.includes("chemist") ? "💊 Chemist:" :
//               activity.includes("stockist") ? "📦 Stockist:" : "📋 Visit:"
//             }</strong>
//           <span style="font-weight:600;color:${activity.includes("chemist") ? "#ec4899" :
//               activity.includes("stockist") ? "#f97316" : "#3b82f6"
//             };">${location.call_name}</span>
//         </div>` : ""}


//       ${location.area_name ? `
//         <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//           <strong style="color:#6b7280;">📍 Area:</strong>
//           <span style="font-weight:500;color:#059669;">${location.area_name}</span>
//         </div>` : ""}

//       <div style="margin-bottom:6px;">
//         <div style="margin-top:4px;">
//           <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//             <strong style="color:#6b7280;">Visit Time:</strong>
//             <span style="font-weight:500;">${formatTimeTo12Hour(location.mobile_time)}</span>
//           </div>
//           <div style="border-top:1px solid #e5e7eb;margin:4px 0;"></div>
//           <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//             <strong style="color:#6b7280;">Server Time:</strong>
//             <span style="font-weight:500;">${formatTimeTo12Hour(location.server_time)}</span>
//           </div>
//         </div>
//       </div>

//       <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//         <strong style="color:#6b7280;">Activity:</strong>
//         <span style="font-weight:500;">${formatActivityType(location.activity_type)}</span>
//       </div>
//       <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//         <strong style="color:#6b7280;">Distance:</strong>
//         <span style="font-weight:500;">${(location.distance_km || 0).toFixed(2)} km</span>
//       </div>
//       <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//         <strong style="color:#6b7280;">Total Distance:</strong>
//         <span style="font-weight:500;color:#3b82f6;">${(location.km_covered || 0).toFixed(2)} km</span>
//       </div>
//       <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//         <strong style="color:#6b7280;">Speed:</strong>
//         <span style="font-weight:500;">${(location.speed || 0).toFixed(1)} m/s</span>
//       </div>
//       <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
//         <strong style="color:#6b7280;">Accuracy:</strong>
//         <span style="font-weight:500;">${(location.accuracy_meter || 0).toFixed(1)} m</span>
//       </div>

//       ${location.address ? `
//         <div style="margin-top:10px;padding-top:10px;border-top:1px solid #e5e7eb;">
//           <strong style="color:#6b7280;">Location:</strong>
//           <div style="margin-top:4px;font-weight:500;">${location.address}</div>
//         </div>` : ""}

//       <div style="margin-top:10px;padding-top:10px;border-top:1px solid #e5e7eb;font-size:12px;color:#9ca3af;">
//         ${lat.toFixed(6)}, ${lng.toFixed(6)}
//       </div>
//     </div>
//   </div>
// `;

//         const infoWindow = new window.google.maps.InfoWindow({
//           content: infoContent,
//         });

//         marker.activityType = activity;
//         marker.locationData = location;
//         marker._infoWindow = infoWindow;

//         marker.addListener("click", () => {
//           infoWindow.open(googleMap, marker);
//           setSelectedLocation(location);
//         });

//         markersRef.current.push(marker);
//       });

//       // ✅ EXPENSE: skip route drawing entirely — each expense visit is independent
//       if (context === "expense") {
//         // No connecting lines between expense visit points
//       } else {
//         const nonTravelPoints = locationData.filter(
//           (loc) => !isTravelActivity(loc.activity_type),
//         );
//         const routePoints =
//           nonTravelPoints.length >= 2
//             ? locationData
//             : locationData;
//         if (routePoints.length >= 2) {
//           drawRoutes(routePoints, googleMap);
//         } else {
//           for (let i = 0; i < locationData.length - 1; i++) {
//             const lat1 = Number(locationData[i].latitude);
//             const lng1 = Number(locationData[i].longitude);
//             const lat2 = Number(locationData[i + 1].latitude);
//             const lng2 = Number(locationData[i + 1].longitude);
//             if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2))
//               continue;
//             const line = new window.google.maps.Polyline({
//               path: [
//                 { lat: lat1, lng: lng1 },
//                 { lat: lat2, lng: lng2 },
//               ],
//               geodesic: true,
//               strokeColor: "#ef4444",
//               strokeOpacity: 0.7,
//               strokeWeight: 3,
//               icons: [
//                 {
//                   icon: { path: "M 0,-1 0,1", strokeOpacity: 1, scale: 6 },
//                   offset: "0",
//                   repeat: "20px",
//                 },
//               ],
//               zIndex: 40,
//             });
//             line.setMap(googleMap);
//             polylinesRef.current.push(line);
//           }
//         }
//       }

//       if (!bounds.isEmpty()) {
//         googleMap.fitBounds(bounds);
//         setTimeout(() => {
//           if (mapInstanceRef.current) {
//             const currentZoom = mapInstanceRef.current.getZoom();
//             if (currentZoom > 15) mapInstanceRef.current.setZoom(15);
//           }
//         }, 300);
//       }

//       // ─── Home marker logic — untouched ───
//       const addrEntry = locationData.find(
//         (l) => l.employee_address && typeof l.employee_address === "string",
//       );
//       const addressString = addrEntry
//         ? String(addrEntry.employee_address).trim()
//         : null;

//       if (addressString && isGoogleReady() && googleMap) {
//         const geocoder = new window.google.maps.Geocoder();
//         const cacheKey = `geocode:${addressString}`;

//         const tryPlaceHome = (latLng) => {
//           try {
//             if (homeMarkerRef.current) {
//               try {
//                 homeMarkerRef.current.setMap(null);
//               } catch (_) { }
//               homeMarkerRef.current = null;
//             }

//             const hm = new window.google.maps.Marker({
//               position: { lat: latLng.lat, lng: latLng.lng },
//               map: googleMap,
//               title: "Home Address",
//               icon: {
//                 url: homeMarker,
//                 size: new window.google.maps.Size(48, 48),
//                 scaledSize: new window.google.maps.Size(36, 36),
//                 anchor: new window.google.maps.Point(18, 36),
//               },
//               zIndex: 3000,
//               optimized: false,
//             });

//             homeMarkerRef.current = hm;

//             const hwInfo = new window.google.maps.InfoWindow({
//               content: `<div style="padding:10px;font-family:sans-serif;"><strong>Home Address</strong><div style="margin-top:6px;font-size:13px;">${addressString}</div></div>`,
//             });

//             hm.addListener("click", () => hwInfo.open(googleMap, hm));

//             try {
//               const latLngObj = new window.google.maps.LatLng(
//                 latLng.lat,
//                 latLng.lng,
//               );
//               bounds.extend(latLngObj);
//               googleMap.fitBounds(bounds);
//               setTimeout(() => {
//                 if (mapInstanceRef.current) {
//                   const currentZoom = mapInstanceRef.current.getZoom();
//                   if (currentZoom > 15) mapInstanceRef.current.setZoom(15);
//                 }
//               }, 300);
//             } catch (e) { }
//           } catch (e) {
//             console.warn("placeHome marker error:", e);
//           }
//         };

//         let cached = null;
//         try {
//           const mem = cacheRef.current.get(cacheKey);
//           if (
//             mem &&
//             mem.lat &&
//             mem.lng &&
//             mem.ts &&
//             Date.now() - mem.ts < 7 * 24 * 60 * 60 * 1000
//           ) {
//             cached = mem;
//           } else if (mem) {
//             cacheRef.current.delete(cacheKey);
//           }
//         } catch (e) {
//           cached = null;
//         }

//         if (!cached && USE_SESSION_FALLBACK) {
//           try {
//             const raw = sessionStorage.getItem(cacheKey);
//             if (raw) {
//               const parsed = JSON.parse(raw);
//               if (
//                 parsed &&
//                 parsed.lat &&
//                 parsed.lng &&
//                 parsed.ts &&
//                 Date.now() - parsed.ts < 7 * 24 * 60 * 60 * 1000
//               ) {
//                 cached = parsed;
//                 try {
//                   cacheRef.current.set(cacheKey, parsed);
//                 } catch (e) { }
//               } else {
//                 try {
//                   sessionStorage.removeItem(cacheKey);
//                 } catch (e) { }
//               }
//             }
//           } catch (e) {
//             cached = null;
//           }
//         }

//         if (cached) {
//           tryPlaceHome({ lat: cached.lat, lng: cached.lng });
//         } else {
//           geocodeAddress(geocoder, addressString)
//             .then((res) => {
//               try {
//                 const payload = { lat: res.lat, lng: res.lng, ts: Date.now() };
//                 try {
//                   cacheRef.current.set(cacheKey, payload);
//                 } catch (e) { }
//                 if (USE_SESSION_FALLBACK) {
//                   try {
//                     sessionStorage.setItem(cacheKey, JSON.stringify(payload));
//                   } catch (e) { }
//                 }
//               } catch (e) { }
//               tryPlaceHome({ lat: res.lat, lng: res.lng });
//             })
//             .catch((err) =>
//               console.warn("Geocode failed for employee_address:", err),
//             );
//         }
//       }
//     } catch (err) {
//       console.error("Error creating map:", err);
//       setError(err.message || "Failed to create map");
//     }
//   }, [context, locationData, mapType, googleLoaded]);

//   // ─── Punch mode effect — untouched ───
//   useEffect(() => {
//     if (
//       (context !== "morningPunch" && context !== "eveningPunch") ||
//       !locationData ||
//       locationData.length === 0 ||
//       !googleLoaded ||
//       !isGoogleReady() ||
//       !mapRef.current
//     )
//       return;

//     console.log("📍 Rendering punch-only map for", context);

//     clearMapElements();
//     setLinearDistance(null);

//     const punchLocation = locationData[0];
//     const punchLat = Number(punchLocation.latitude);
//     const punchLng = Number(punchLocation.longitude);

//     if (isNaN(punchLat) || isNaN(punchLng)) {
//       setError("Invalid punch coordinates");
//       return;
//     }

//     const isMorning = context === "morningPunch";

//     const googleMap = new window.google.maps.Map(mapRef.current, {
//       zoom: 13,
//       center: { lat: punchLat, lng: punchLng },
//       mapTypeId: mapType,
//       mapTypeControl: true,
//       streetViewControl: false,
//       fullscreenControl: true,
//       zoomControl: true,
//     });

//     mapInstanceRef.current = googleMap;
//     setMap(googleMap);

//     const bounds = new window.google.maps.LatLngBounds();
//     bounds.extend({ lat: punchLat, lng: punchLng });

//     const punchMarker = new window.google.maps.Marker({
//       position: { lat: punchLat, lng: punchLng },
//       map: googleMap,
//       title: isMorning ? "Morning Punch In" : "Evening Punch Out",
//       icon: {
//         url: isMorning ? punchInIcon : punchExitIcon,
//         scaledSize: new window.google.maps.Size(52, 52),
//         anchor: new window.google.maps.Point(26, 52),
//       },
//       zIndex: 3000,
//       optimized: false,
//     });
//     markersRef.current.push(punchMarker);

//     const punchTime = formatTimeTo12Hour(
//       punchLocation.mobile_time || punchLocation.server_time,
//     );

//     const punchInfo = new window.google.maps.InfoWindow({
//       content: `
//         <div style="padding:12px;font-family:sans-serif;min-width:220px;">
//           <div style="font-weight:700;font-size:15px;color:${isMorning ? "#f59e0b" : "#3b82f6"};margin-bottom:8px;">
//             ${isMorning ? "🌅 Morning Punch In" : "🌙 Evening Punch Out"}
//           </div>
//           <div style="font-size:13px;color:#1f2937;line-height:1.8;">
//             <div><strong>Time:</strong> ${punchTime}</div>
//             ${punchLocation.address ? `<div style="margin-top:6px;"><strong>Location:</strong><br/>${punchLocation.address}</div>` : ""}
//             <div style="margin-top:4px;font-size:11px;color:#9ca3af;">${punchLat.toFixed(6)}, ${punchLng.toFixed(6)}</div>
//           </div>
//         </div>
//       `,
//     });

//     punchMarker.addListener("click", () =>
//       punchInfo.open(googleMap, punchMarker),
//     );
//     punchInfo.open(googleMap, punchMarker);
//     setSelectedLocation(punchLocation);

//     const addrString =
//       residenceAddress ||
//       (punchLocation.employee_address
//         ? String(punchLocation.employee_address).trim()
//         : null);

//     if (addrString && isGoogleReady()) {
//       const geocoder = new window.google.maps.Geocoder();

//       geocoder.geocode({ address: addrString }, (results, status) => {
//         if (status !== "OK" || !results[0]) {
//           console.warn("Geocode failed for home address:", status);
//           return;
//         }

//         const homeLoc = results[0].geometry.location;
//         const homeLat = homeLoc.lat();
//         const homeLng = homeLoc.lng();

//         const hm = new window.google.maps.Marker({
//           position: { lat: homeLat, lng: homeLng },
//           map: googleMap,
//           title: "Home Address",
//           icon: {
//             url: homeMarker,
//             scaledSize: new window.google.maps.Size(36, 36),
//             anchor: new window.google.maps.Point(18, 36),
//           },
//           zIndex: 3000,
//           optimized: false,
//         });
//         homeMarkerRef.current = hm;

//         const homeInfo = new window.google.maps.InfoWindow({
//           content: `
//             <div style="padding:10px;font-family:sans-serif;">
//               <strong>🏠 Home Address</strong>
//               <div style="margin-top:6px;font-size:13px;">${addrString}</div>
//             </div>
//           `,
//         });
//         hm.addListener("click", () => homeInfo.open(googleMap, hm));

//         const connectingLine = new window.google.maps.Polyline({
//           path: [
//             { lat: punchLat, lng: punchLng },
//             { lat: homeLat, lng: homeLng },
//           ],
//           geodesic: true,
//           strokeColor: "#ef4444",
//           strokeOpacity: 1.0,
//           strokeWeight: 2,
//         });
//         connectingLine.setMap(googleMap);
//         polylinesRef.current.push(connectingLine);

//         const R = 6371;
//         const dLat = ((homeLat - punchLat) * Math.PI) / 180;
//         const dLng = ((homeLng - punchLng) * Math.PI) / 180;
//         const a =
//           Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//           Math.cos((punchLat * Math.PI) / 180) *
//           Math.cos((homeLat * Math.PI) / 180) *
//           Math.sin(dLng / 2) *
//           Math.sin(dLng / 2);
//         const distKm = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

//         if (!cancelledRef.current) {
//           setLinearDistance({
//             km: distKm.toFixed(2),
//             label: isMorning
//               ? "Home Location and Morning Punch Location"
//               : "Home Location and Evening Punch Location",
//           });
//         }

//         bounds.extend({ lat: homeLat, lng: homeLng });
//         googleMap.fitBounds(bounds);
//         setTimeout(() => {
//           if (mapInstanceRef.current) {
//             const z = mapInstanceRef.current.getZoom();
//             if (z > 14) mapInstanceRef.current.setZoom(14);
//           }
//         }, 300);
//       });
//     }
//   }, [context, locationData, mapType, residenceAddress, googleLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

//   // ─── EFFECT 5: Sync mapType — untouched ───
//   useEffect(() => {
//     if (mapInstanceRef.current && isGoogleReady()) {
//       try {
//         mapInstanceRef.current.setMapTypeId(mapType);
//       } catch (_) { }
//     }
//   }, [mapType]);

//   // ─── Animation — untouched ───
//   const startAnimation = () => {
//     if (
//       context === "compare" ||
//       !mapInstanceRef.current ||
//       locationData.length === 0 ||
//       isAnimating ||
//       !isGoogleReady()
//     )
//       return;

//     setIsAnimating(true);
//     setAnimationIndex(0);

//     if (animationMarkerRef.current) {
//       try {
//         animationMarkerRef.current.setMap(null);
//       } catch (_) { }
//     }

//     const newAnimationMarker = new window.google.maps.Marker({
//       map: mapInstanceRef.current,
//       icon: {
//         path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
//         scale: 6,
//         fillColor: "#ef4444",
//         fillOpacity: 1,
//         strokeColor: "#ffffff",
//         strokeWeight: 2,
//         rotation: 0,
//       },
//       zIndex: 2000,
//       optimized: false,
//     });

//     animationMarkerRef.current = newAnimationMarker;
//     animateMovement(newAnimationMarker, 0);
//   };

//   const animateMovement = (marker, index) => {
//     if (index >= locationData.length) {
//       setIsAnimating(false);
//       return;
//     }

//     const location = locationData[index];
//     const position = {
//       lat: Number(location.latitude),
//       lng: Number(location.longitude),
//     };

//     try {
//       marker.setPosition(position);
//       if (mapInstanceRef.current) mapInstanceRef.current.panTo(position);

//       const infoWindow = new window.google.maps.InfoWindow({
//         content: `
//           <div style="padding:10px;font-family:sans-serif;">
//             <div style="font-weight:700;color:#ef4444;margin-bottom:6px;">${getActivityIcon(location.activity_type)} ${getActivityLabel(location.activity_type)}</div>
//             <div style="font-size:13px;">
//               <div><strong>Date:</strong> ${formatDate(location.mobile_time)}</div>
//               <div><strong>Distance:</strong> ${(location.distance_km || 0).toFixed(2)} km</div>
//             </div>
//           </div>
//         `,
//       });

//       infoWindow.open(mapInstanceRef.current, marker);
//       setAnimationIndex(index);
//       setSelectedLocation(location);
//       setTimeout(() => {
//         try {
//           infoWindow.close();
//         } catch (_) { }
//       }, 2000);
//     } catch (err) {
//       console.warn("animateMovement step error:", err);
//     }

//     animationRef.current = setTimeout(
//       () => animateMovement(marker, index + 1),
//       1500,
//     );
//   };

//   const pauseAnimation = () => {
//     setIsAnimating(false);
//     if (animationRef.current) clearTimeout(animationRef.current);
//   };

//   const resetAnimation = () => {
//     pauseAnimation();
//     setAnimationIndex(0);
//     if (animationMarkerRef.current) {
//       try {
//         animationMarkerRef.current.setMap(null);
//       } catch (_) { }
//       animationMarkerRef.current = null;
//     }
//     setSelectedLocation(null);
//   };

//   const summaryStats = React.useMemo(() => {
//     if (context === "compare" || !locationData || locationData.length === 0)
//       return null;

//     const punchIn = locationData.find(
//       (l) =>
//         (l.activity_type || "").toLowerCase().includes("punch_in") ||
//         (l.activity_type || "").toLowerCase().includes("morning_punch"),
//     );

//     const punchOut = locationData.find(
//       (l) =>
//         (l.activity_type || "").toLowerCase().includes("punch_out") ||
//         (l.activity_type || "").toLowerCase().includes("evening_punch"),
//     );

//     const visits = locationData.filter((l) => {
//       const activity = (l.activity_type || "").toLowerCase();
//       return (
//         activity.includes("visit") ||
//         activity.includes("doctor") ||
//         activity.includes("chemist") ||
//         activity.includes("stockist") ||
//         activity.includes("call")
//       );
//     }).length;

//     const totalDistance =
//       locationData.length > 0
//         ? Number(locationData[locationData.length - 1].km_covered || 0)
//         : 0;

//     return {
//       punchIn,
//       punchOut,
//       visits,
//       totalDistance,
//       totalPoints: locationData.length,
//     };
//   }, [context, locationData]);

//   const punchHeaderTimes = React.useMemo(() => {
//     if (!locationData || fullDayLocations.length === 0) {
//       return {
//         morningPunch: null,
//         eveningPunch: null,
//         firstCall: null,
//         lastCall: null,
//       };
//     }
//     const sorted = [...fullDayLocations].sort(
//       (a, b) =>
//         new Date(a.server_time).getTime() - new Date(b.server_time).getTime(),
//     );

//     const morningPunch = sorted.find((l) =>
//       (l.activity_type || "").toLowerCase().includes("morning_punch"),
//     );

//     const eveningPunch = sorted.find((l) =>
//       (l.activity_type || "").toLowerCase().includes("evening_punch"),
//     );

//     const calls = sorted.filter((l) => {
//       const type = (l.activity_type || "").toLowerCase();
//       return type.includes("call") && !type.includes("punch");
//     });

//     return {
//       morningPunch: morningPunch?.server_time || null,
//       eveningPunch: eveningPunch?.server_time || null,
//       firstCall: calls[0]?.server_time || null,
//       lastCall: calls[calls.length - 1]?.server_time || null,
//     };
//   }, [fullDayLocations]);

//   const focusOnActivity = (keyword) => {
//     if (context === "compare") return;
//     try {
//       if (
//         !mapInstanceRef.current ||
//         !markersRef.current ||
//         markersRef.current.length === 0
//       )
//         return;

//       const key = (keyword || "").toLowerCase();
//       const matched = markersRef.current.filter((m) => {
//         const at = (m.activityType || "").toLowerCase();
//         return at.includes(key);
//       });

//       if (!matched || matched.length === 0) {
//         const loose = markersRef.current.filter((m) => {
//           const at = (m.activityType || "").toLowerCase();
//           return (
//             (key === "punch" && at.includes("punch")) ||
//             (key === "visit" && (at.includes("visit") || at.includes("call")))
//           );
//         });
//         if (loose && loose.length > 0) {
//           panToMarkers(loose);
//           openMarkerInfo(loose[0]);
//         } else {
//           console.info("No markers found for:", key);
//         }
//         return;
//       }

//       panToMarkers(matched);
//       openMarkerInfo(matched[0]);
//     } catch (e) {
//       console.warn("focusOnActivity error", e);
//     }
//   };

//   const panToMarkers = (markerList) => {
//     if (
//       !markerList ||
//       markerList.length === 0 ||
//       !mapInstanceRef.current ||
//       !isGoogleReady()
//     )
//       return;

//     if (markerList.length === 1) {
//       try {
//         const pos = markerList[0].getPosition
//           ? markerList[0].getPosition()
//           : null;
//         if (pos) {
//           mapInstanceRef.current.panTo({ lat: pos.lat(), lng: pos.lng() });
//           mapInstanceRef.current.setZoom(
//             Math.max(mapInstanceRef.current.getZoom(), 15),
//           );
//         }
//       } catch (_) { }
//       return;
//     }

//     try {
//       const bounds = new window.google.maps.LatLngBounds();
//       markerList.forEach((m) => {
//         try {
//           const pos = m.getPosition ? m.getPosition() : null;
//           if (pos) bounds.extend(pos);
//         } catch (_) { }
//       });
//       mapInstanceRef.current.fitBounds(bounds);
//       setTimeout(() => {
//         try {
//           if (mapInstanceRef.current) {
//             const currentZoom = mapInstanceRef.current.getZoom();
//             if (currentZoom > 15) mapInstanceRef.current.setZoom(15);
//           }
//         } catch (_) { }
//       }, 250);
//     } catch (e) {
//       console.warn("panToMarkers fitBounds failed", e);
//     }
//   };

//   const openMarkerInfo = (marker) => {
//     if (!marker || !mapInstanceRef.current) return;
//     try {
//       if (marker._infoWindow) {
//         marker._infoWindow.open(mapInstanceRef.current, marker);
//         setSelectedLocation(marker.locationData || null);
//       } else {
//         window.google.maps.event.trigger(marker, "click");
//       }
//     } catch (e) {
//       console.warn("openMarkerInfo error", e);
//     }
//   };

//   const handleClose = () => {
//     if (typeof onClose === "function") onClose();
//     else navigate(-1);
//   };

//   const handleRefresh = () => {
//     if (context === "compare") fetchCompareLocations();
//     else if (context !== "homeOnly") fetchLocationData();
//   };

//   const outerClass = isModal
//     ? "flex flex-col h-full w-full"
//     : "bg-gradient-to-br from-gray-50 to-blue-50 p-4";
//   const innerContainerClass = isModal
//     ? "flex flex-col flex-1 overflow-hidden"
//     : "max-w-7xl mx-auto";

//   if (loading) {
//     return (
//       <div className={`${outerClass} items-center justify-center`}>
//         <div className="text-center bg-white p-6 rounded-2xl shadow-lg">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600 mx-auto mb-3" />
//           <p className="text-lg text-gray-700 font-semibold">
//             Loading Map Tracker...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className={`${outerClass} items-center justify-center p-4`}>
//         <div className="text-center p-6 bg-white rounded-2xl shadow-lg border-2 border-red-100 max-w-lg">
//           <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-3" />
//           <h3 className="text-xl font-bold text-gray-800 mb-2">
//             Unable to Load Map
//           </h3>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <div className="flex items-center justify-center gap-3">
//             <button
//               onClick={handleRefresh}
//               className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//             >
//               Try Again
//             </button>
//             <button
//               onClick={handleClose}
//               className="px-4 py-2 bg-gray-200 rounded-lg"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!loading && !error && locationData.length === 0 && context !== "compare" && context !== "homeOnly") {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <div className="relative text-center p-6 bg-white rounded-2xl shadow-lg">
//           <button
//             onClick={onClose}
//             className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
//           >
//             <X className="h-4 w-4" />
//           </button>
//           <MapPin className="h-12 w-12 text-gray-300 mx-auto mb-3" />
//           <h3 className="text-lg font-bold text-gray-600">No Location Data</h3>
//           <p className="text-gray-400 text-sm mt-1">
//             No tracking data found for this date.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className={outerClass}>
//       <div className={innerContainerClass}>
//         {/* Header */}
//         <div
//           className={
//             isModal
//               ? "flex items-center justify-between gap-4 p-3 border-b bg-white"
//               : "bg-white rounded-t-2xl shadow-lg p-6 border-b-2 border-blue-100"
//           }
//         >
//           <div className="flex items-center gap-4">
//             <div className="p-2 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-sm">
//               <Navigation className="h-6 w-6 text-white" />
//             </div>
//             <div>
//               <h1 className="font-bold text-gray-800 text-sm md:text-lg">
//                 {context === "compare"
//                   ? "Compare Employee Locations"
//                   : context === "expense"
//                     ? "Expense Visit Locations" // ✅ custom title for expense
//                     : "Employee Movement Tracker"}
//               </h1>
//               <p className="text-xs text-gray-500 mt-0.5">
//                 {employeeName && `${employeeName} • `}
//                 {date && formatDate(new Date(date), "DD MMM YYYY")}
//                 {context === "compare" && compareLocations.length > 0 && (
//                   <span className="ml-2 text-blue-600">
//                     ({compareLocations.length} comparison points)
//                   </span>
//                 )}
//                 {context !== "compare" && locationData.length > 0 && (
//                   <span className="ml-2 text-teal-600">
//                     ({locationData.length} expense visit{locationData.length !== 1 ? "s" : ""})
//                   </span>
//                 )}
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-2">
//             <button
//               onClick={handleRefresh}
//               className="flex items-center gap-2 px-3 py-1.5 bg-white border rounded-lg shadow-sm text-sm hover:bg-gray-50"
//             >
//               <RefreshCw className="h-4 w-4" /> Refresh
//             </button>
//             <button
//               onClick={() =>
//                 setMapType((prev) =>
//                   prev === "roadmap" ? "satellite" : "roadmap",
//                 )
//               }
//               className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg text-sm hover:from-blue-600 hover:to-indigo-700"
//             >
//               <Layers className="h-4 w-4" />{" "}
//               {mapType === "roadmap" ? "Satellite" : "Map"}
//             </button>
//             <button
//               onClick={handleClose}
//               className="flex items-center gap-2 px-3 py-1.5 bg-red-500 text-white rounded-lg text-sm hover:bg-red-600"
//             >
//               <XIcon className="h-4 w-4" /> Close
//             </button>
//           </div>
//         </div>

//         {/* ─── Route & Location info bar ─── */}
//         {context === "viewMap" &&
//           (routeName || latestLocation || gpsStop || locationCount > 0) && (
//             <div className="flex flex-wrap items-center gap-x-6 gap-y-1 px-4 py-2 bg-indigo-950 text-white text-xs border-b border-indigo-800">
//               {punchHeaderTimes.morningPunch && (
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-white-700">Punch In:</span>
//                   <span className="font-semibold text-yellow-300">
//                     {formatTimeTo12Hour(punchHeaderTimes.morningPunch)}
//                   </span>
//                 </div>
//               )}
//               {punchHeaderTimes.firstCall && (
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-white-700">First Call:</span>
//                   <span className="font-semibold text-green-300">
//                     {formatTimeTo12Hour(punchHeaderTimes.firstCall)}
//                   </span>
//                 </div>
//               )}
//               {latestLocation && (
//                 <div className="flex items-center gap-1.5 min-w-0">
//                   <span className="text-white-700 shrink-0">Location Found -</span>
//                   <span
//                     className="font-semibold text-yellow-200 truncate max-w-[180px]"
//                     title={latestLocation}
//                   >
//                     {latestLocation}
//                   </span>
//                   <span className="text-white-700 shrink-0"> on </span>
//                   <span className="font-semibold text-yellow-200">
//                     {gpsStopIdleTime}
//                   </span>
//                 </div>
//               )}
//               {routeName && (
//                 <div className="flex items-center gap-1.5 min-w-0">
//                   <span className="text-white-700 shrink-0">Route Filled- </span>
//                   <span
//                     className="font-semibold text-green-200 truncate max-w-[160px]"
//                     title={routeName}
//                   >
//                     {routeName}
//                   </span>
//                 </div>
//               )}
//               {punchHeaderTimes.lastCall && (
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-white-700">Last Call:</span>
//                   <span className="font-semibold text-blue-300">
//                     {formatTimeTo12Hour(punchHeaderTimes.lastCall)}
//                   </span>
//                 </div>
//               )}
//               {punchHeaderTimes.eveningPunch && (
//                 <div className="flex items-center gap-1.5">
//                   <img
//                     src={punchExitIcon}
//                     alt="punch-exit"
//                     className="w-4 h-4 object-contain opacity-90"
//                   />
//                   <span className="text-white-700">Punch Out:</span>
//                   <span className="font-semibold text-red-300">
//                     {formatTimeTo12Hour(punchHeaderTimes.eveningPunch)}
//                   </span>
//                 </div>
//               )}
//             </div>
//           )}

//         {/* ─── Punch info header bar ─── */}
//         {(context === "morningPunch" || context === "eveningPunch") && (
//           <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2 bg-gray-900 text-white text-xs">
//             <div className="flex items-center gap-2">
//               <img
//                 src={punchInIcon}
//                 alt="punch-in"
//                 className="w-6 h-6 object-contain"
//               />
//               <span>
//                 <span className="text-gray-400">Punch In Time </span>
//                 <span className="font-semibold text-yellow-300">
//                   {formatTimeTo12Hour(punchHeaderTimes.morningPunch) || "-"}
//                 </span>
//               </span>
//             </div>
//             <div className="text-center">
//               <span className="text-gray-400">First Call Time </span>
//               <span className="font-semibold text-green-300">
//                 {formatTimeTo12Hour(punchHeaderTimes.firstCall) || "-"}
//               </span>
//             </div>
//             <div className="text-center">
//               <span className="text-gray-400">Last Call Time </span>
//               <span className="font-semibold text-blue-300">
//                 {formatTimeTo12Hour(punchHeaderTimes.lastCall) || "-"}
//               </span>
//             </div>
//             <div className="flex items-center gap-2">
//               <img
//                 src={punchExitIcon}
//                 alt="punch-exit"
//                 className="w-6 h-6 object-contain"
//               />
//               <span>
//                 <span className="text-gray-400">Punch Exit Time </span>
//                 <span className="font-semibold text-red-300">
//                   {formatTimeTo12Hour(punchHeaderTimes.eveningPunch) || "-"}
//                 </span>
//               </span>
//             </div>
//           </div>
//         )}

//         {/* Map area */}
//         <div className="flex-1 flex flex-col min-h-0 overflow-hidden bg-white relative">
//           {/* Search Bar */}
//           {isGoogleReady() && map && (
//             <div
//               style={{
//                 position: "absolute",
//                 top: "12px",
//                 left: "50%",
//                 marginLeft: "-200px",
//                 zIndex: 9999,
//                 width: "400px",
//                 maxWidth: "calc(90% - 20px)",
//               }}
//             >
//               <div className="flex items-center bg-white rounded-xl shadow-lg border border-gray-200 px-3 py-2 gap-2">
//                 <Search className="h-4 w-4 text-gray-400 shrink-0" />
//                 <input
//                   ref={(el) => {
//                     searchInputRef.current = el;
//                     if (el && !searchReady) setSearchReady(true);
//                   }}
//                   type="text"
//                   placeholder="Search location on map..."
//                   className="flex-1 text-sm text-gray-700 placeholder-gray-400 outline-none bg-transparent"
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//                 {searchQuery && (
//                   <button
//                     onClick={() => {
//                       setSearchQuery("");
//                       if (searchInputRef.current)
//                         searchInputRef.current.value = "";
//                     }}
//                     className="text-gray-400 hover:text-gray-600"
//                   >
//                     <XIcon className="h-3.5 w-3.5" />
//                   </button>
//                 )}
//               </div>
//             </div>
//           )}

//           <div
//             ref={mapRef}
//             className="flex-1 min-h-0 w-full"
//             style={{ minHeight: 0 }}
//           />
//           {totalDistance > 0 && (
//             <div className="absolute top-3 right-16 z-50 bg-blue-600 text-white rounded-full px-4 py-2 text-sm font-bold shadow-lg">
//               🚗 {Number(totalDistance).toFixed(2)} KM
//             </div>
//           )}

//           {/* ✅ Bottom legend: expense context shows only the expense button */}
//           {summaryStats &&
//             context !== "compare" &&
//             context !== "morningPunch" &&
//             context !== "eveningPunch" && (
//               <div
//                 style={{
//                   position: "absolute",
//                   bottom: "12px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   zIndex: 9998,
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 <div
//                   className="flex flex-wrap items-center justify-center gap-1 px-3 py-1.5 rounded-full shadow-lg border border-white/30"
//                   style={{
//                     background: "rgba(17,24,39,0.72)",
//                     backdropFilter: "blur(8px)",
//                   }}
//                 >
//                   {context === "expense" ? (
//                     // ✅ Expense mode: only show the expense legend button
//                     <button
//                       onClick={() => focusOnActivity("add_expense_visit")}
//                       className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium transition-all hover:scale-105 active:scale-95"
//                       style={{
//                         background: "#14b8a622",
//                         border: "1px solid #14b8a655",
//                         color: "#f9fafb",
//                       }}
//                       title="Focus Expense Visits"
//                     >
//                       <span>🧾</span>
//                       <span>Expense Visit</span>
//                     </button>
//                   ) : (
//                     // ─── All other contexts: original legend buttons unchanged ───
//                     <>
//                       {[
//                         { key: "morning_punch", color: "#10b981", emoji: "🟢", label: "Punch In" },
//                         { key: "punch_out", color: "#ef4444", emoji: "🔴", label: "Punch Out" },
//                         { key: "doctor", color: "#8b5cf6", emoji: "🏥", label: "Doctor" },
//                         { key: "chemist", color: "#ec4899", emoji: "💊", label: "Chemist" },
//                         { key: "stockist", color: "#f97316", emoji: "📦", label: "Stockist" },
//                         { key: "last_call", color: "#06b6d4", emoji: "📞", label: "Last Call" },
//                       ].map(({ key, color, emoji, label }) => (
//                         <button
//                           key={key}
//                           onClick={() => focusOnActivity(key)}
//                           className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium transition-all hover:scale-105 active:scale-95"
//                           style={{
//                             background: `${color}22`,
//                             border: `1px solid ${color}55`,
//                             color: "#f9fafb",
//                           }}
//                           title={`Focus ${label}`}
//                         >
//                           <span>{emoji}</span>
//                           <span>{label}</span>
//                         </button>
//                       ))}
//                       <div
//                         className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
//                         style={{
//                           background: "#3b82f622",
//                           border: "1px solid #3b82f655",
//                           color: "#f9fafb",
//                         }}
//                       >
//                         <svg width="18" height="6" viewBox="0 0 18 6">
//                           <line
//                             x1="0"
//                             y1="3"
//                             x2="18"
//                             y2="3"
//                             // stroke="#3b82f6"
//                             stroke="#ef4444"
//                             strokeWidth="2.5"
//                             strokeDasharray="4 2"
//                           />
//                         </svg>
//                         <span>Route</span>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             )}
//         </div>

//         {/* ─── Linear distance footer (only in punch contexts) — untouched ─── */}
//         {(context === "morningPunch" || context === "eveningPunch") &&
//           linearDistance && (
//             <div className="px-4 py-3 bg-gray-100 border-t-2 border-gray-200 text-sm font-medium text-gray-700 text-center">
//               Approximate Linear Distance Between ( {linearDistance.label} ) :{" "}
//               <span className="text-blue-700 font-bold">
//                 {linearDistance.km} KM
//               </span>
//             </div>
//           )}

//         {/* Compare mode legend — untouched */}
//         {context === "compare" && compareLocations.length > 0 && (
//           <div className="px-3 py-3 bg-gradient-to-br from-gray-50 to-blue-50 border-t-2 border-blue-100">
//             <div className="flex flex-wrap items-center justify-center gap-4 text-sm bg-white p-3 rounded-lg border-2 border-gray-200 shadow-sm">
//               <div className="flex items-center gap-2">
//                 <div className="w-6 h-6 rounded bg-green-600" />
//                 <span className="text-gray-700 font-medium">
//                   Individual (IND) - All Positions
//                 </span>
//               </div>
//               <div className="flex items-center gap-2">
//                 <div className="w-6 h-6 rounded bg-blue-600" />
//                 <span className="text-gray-700 font-medium">
//                   Senior (SR) - All Positions
//                 </span>
//               </div>
//               <div className="flex items-center gap-2">
//                 <div className="w-6 h-6 rounded bg-red-600" />
//                 <span className="text-gray-700 font-medium">
//                   Junior (JR) - All Positions
//                 </span>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EmployeeMapTracker;


import React, { useState, useEffect, useRef } from "react";
import {
  X,
  MapPin,
  Clock,
  Navigation,
  Layers,
  AlertCircle,
  RefreshCw,
  Activity,
  Play,
  Pause,
  Search,
  RotateCcw,
  X as XIcon,
} from "lucide-react";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import { formatDate } from "../utils/formatDate";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import homeMarker from "../images/homeMarker.png";
import { loadGoogleMaps } from "../utils/loadGoogleMaps";
import { formatTimeTo12Hour } from "../utils/formatTime";
import formatActivityType from "../Admin/ActivityEnum";

import punchInIcon from "../images/punch_in.png";
import punchExitIcon from "../images/punch_exit.png";

const geocodeAddress = (geocoder, address) => {
  return new Promise((resolve, reject) => {
    try {
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results[0]) {
          const loc = results[0].geometry.location;
          resolve({ lat: loc.lat(), lng: loc.lng(), raw: results[0] });
        } else {
          reject(new Error(`Geocode failed: ${status}`));
        }
      });
    } catch (err) {
      reject(err);
    }
  });
};

const EmployeeMapTracker = ({
  onClose,
  employeeId: propEmployeeId,
  trackDate: propDate,
  employeeName,
  isModal = false,
  context = "single",
  visitId: propVisitId,
  residenceAddress,
  specificPunchTime = null,
  firstCallTime = "",
  lastCallTime = "",
  morningPunchTime = "",
  eveningPunchTime = "",
  routeName = "",
  latestLocation = "",
  gpsStop = "",
  locationCount = 0,
  gpsStopIdleTime = "",
  visits = 0,
  pob = 0,
}) => {
  const { locId } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const qs = new URLSearchParams(search);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [searchReady, setSearchReady] = useState(false);
  const employeeIdParam =
    qs.get("employee_id") ||
    qs.get("employeeId") ||
    qs.get("emp_id") ||
    qs.get("empId") ||
    "";
  const visitId =
    propVisitId ||
    qs.get("visit_id") ||
    qs.get("visitId") ||
    "";
  const dateParam =
    qs.get("track_date") ||
    qs.get("trackDate") ||
    qs.get("date") ||
    qs.get("working_date") ||
    "";

  const employeeId =
    propEmployeeId ||
    employeeIdParam ||
    sessionStorage.getItem("location_history_employee_id") ||
    "";
  const date =
    propDate ||
    dateParam ||
    sessionStorage.getItem("location_history_track_date") ||
    "";

  const [map, setMap] = useState(null);
  const [mapType, setMapType] = useState("roadmap");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [locationData, setLocationData] = useState([]);
  const [compareLocations, setCompareLocations] = useState([]);
  const [fullDayLocations, setFullDayLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [animationIndex, setAnimationIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [googleLoaded, setGoogleLoaded] = useState(false);
  const [linearDistance, setLinearDistance] = useState(null);
  const mapRef = useRef(null);
  const animationRef = useRef(null);
  const cacheRef = useRef(new Map());
  const USE_SESSION_FALLBACK = true;
  const [totalDistance, setTotalDistance] = useState(0);

  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);
  const polylinesRef = useRef([]);
  const animationMarkerRef = useRef(null);
  const homeMarkerRef = useRef(null);
  const cancelledRef = useRef(false);

  const isGoogleReady = () =>
    typeof window !== "undefined" &&
    window.google &&
    window.google.maps &&
    typeof window.google.maps.Map === "function";

  const normalizeDateForApi = (dateStr) => {
    if (!dateStr) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
    const d = new Date(dateStr);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const getCompareRole = (employeeType) => {
    if (!employeeType) return "JR";
    const t = String(employeeType).toLowerCase();
    if (t === "individual") return "IND";
    if (t === "sr" || t === "manager") return "SR";
    if (t === "jr") return "JR";
    return "JR";
  };

  const buildVisitMarkerSVG = ({ time, name, bgColor }) => `
<svg width="160" height="60" xmlns="http://www.w3.org/2000/svg">
  <rect x="10" y="5" rx="6" ry="6" width="140" height="22" fill="#111827"/>
  <text x="80" y="21" text-anchor="middle"
        font-size="12" font-weight="700" fill="#ffffff" font-family="Arial">
    ${time}
  </text>
  <rect x="10" y="30" rx="6" ry="6" width="140" height="22" fill="${bgColor}"/>
  <text x="80" y="46" text-anchor="middle"
        font-size="11" font-weight="600" fill="#ffffff" font-family="Arial">
    ${name}
  </text>
</svg>`;

  const buildCompareMarkerSVG = ({ role, time, bg }) => `
<svg width="90" height="58" xmlns="http://www.w3.org/2000/svg">
  <rect x="10" y="2" rx="6" ry="6" width="70" height="22" fill="${bg}" />
  <text x="45" y="18" text-anchor="middle"
        font-size="12" font-weight="700" fill="#fff" font-family="Arial">
    ${role}
  </text>
  <rect x="12" y="28" rx="6" ry="6" width="66" height="22" fill="#111827" />
  <text x="45" y="44" text-anchor="middle"
        font-size="11" font-weight="600" fill="#fff" font-family="Arial">
    ${time}
  </text>
</svg>`;

  // ✅ UPDATED: includes add_expense_visit
  const getActivityColor = (activityType) => {
    const activity = (activityType || "").toLowerCase();
    if (activity.includes("employee_address") || activity === "employee_address") return "#f59e0b";
    if (activity.includes("punch_in") || activity.includes("morning_punch") || activity === "punched") return "#10b981";
    if (activity.includes("punch_out") || activity.includes("evening_punch") || activity.includes("exit")) return "#ef4444";
    if (activity.includes("add_doctor_visit")) return "#8b5cf6";
    if (activity.includes("add_chemist_visit")) return "#ec4899";
    if (activity.includes("add_stockist_visit")) return "#f97316";
    if (activity.includes("last_call")) return "#06b6d4";
    if (activity.includes("add_expense_visit")) return "#14b8a6"; // ✅ teal
    if (activity.includes("visit") || activity.includes("call")) return "#3b82f6";
    return "#6b7280";
  };

  // ✅ UPDATED: includes add_expense_visit
  const getActivityLabel = (activityType) => {
    const activity = (activityType || "").toLowerCase();
    if (activity.includes("employee_address") || activity === "employee_address") return "Home Address";
    if (activity.includes("punch_in") || activity.includes("morning_punch") || activity === "punched") return "Punch In";
    if (activity.includes("punch_out") || activity.includes("evening_punch")) return "Punch Out";
    if (activity.includes("exit")) return "Exit";
    if (activity.includes("add_doctor_visit")) return "Doctor Visit";
    if (activity.includes("add_chemist_visit")) return "Chemist Visit";
    if (activity.includes("add_stockist_visit")) return "Stockist Visit";
    if (activity.includes("last_call")) return "Last Call";
    if (activity.includes("add_expense_visit")) return "Expense Visit"; // ✅
    if (activity.includes("visit")) return "Visit";
    if (activity.includes("call_stop")) return "Call Stop";
    if (activity.includes("call")) return "Call";
    return "Activity";
  };

  // ✅ UPDATED: includes add_expense_visit
  const getActivityIcon = (activityType) => {
    const activity = (activityType || "").toLowerCase();
    if (activity.includes("employee_address") || activity === "employee_address") return "🏠";
    if (activity.includes("punch_in") || activity.includes("morning_punch") || activity === "punched") return "🚀";
    if (activity.includes("punch_out") || activity.includes("evening_punch")) return "🏁";
    if (activity.includes("add_doctor_visit")) return "🏥";
    if (activity.includes("add_chemist_visit")) return "💊";
    if (activity.includes("add_stockist_visit")) return "📦";
    if (activity.includes("last_call")) return "📞";
    if (activity.includes("add_expense_visit")) return "🧾"; // ✅
    if (activity.includes("visit")) return "🏢";
    if (activity.includes("call_stop")) return "📵";
    if (activity.includes("call")) return "📞";
    return "📍";
  };

  const getActivityMarkerIcon = (activityType, scale = 11) => {
    const activity = (activityType || "").toLowerCase().trim();

    const isLarge = scale >= 14;
    const size = isLarge ? 52 : 42;
    const half = size / 2;
    const iconSize = isLarge ? 18 : 15;
    const iconOffset = isLarge ? 7 : 6;

    const makePin = (bgColor, borderColor, iconPaths) => ({
      url:
        "data:image/svg+xml;charset=UTF-8," +
        encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size + 12}" viewBox="0 0 ${size} ${size + 12}">
          <ellipse cx="${half}" cy="${size + 10}" rx="${half * 0.45}" ry="2.5" fill="rgba(0,0,0,0.18)"/>
          <path d="M${half},${size + 5} C${half},${size + 5} 2,${half + 10} 2,${half} A${half - 2},${half - 2} 0 1,1 ${size - 2},${half} C${size - 2},${half + 10} ${half},${size + 5} ${half},${size + 5} Z"
                fill="${bgColor}" stroke="${borderColor}" stroke-width="1.5"/>
          <circle cx="${half}" cy="${half}" r="${half * 0.54}" fill="white" opacity="0.97"/>
          <g transform="translate(${half - iconSize / 2}, ${half - iconSize / 2}) scale(${iconSize / 24})">
            ${iconPaths}
          </g>
        </svg>
      `),
      scaledSize: new window.google.maps.Size(size, size + 12),
      anchor: new window.google.maps.Point(half, size + 12),
    });

    // ── Home / Employee Address ──
    if (activity.includes("employee_address"))
      return makePin(
        "#f59e0b",
        "#d97706",
        `
      <path d="M3 12L12 3l9 9" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <path d="M9 21V12h6v9" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <rect x="3" y="12" width="18" height="9" rx="1" stroke="#f59e0b" stroke-width="2" fill="none"/>
    `,
      );

    // ── Morning Punch In ──
    if (
      activity.includes("punch_in") ||
      activity.includes("morning_punch") ||
      activity === "punched"
    )
      return makePin(
        "#10b981",
        "#059669",
        `
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <polyline points="10 17 15 12 10 7" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <line x1="15" y1="12" x2="3" y2="12" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
    `,
      );

    // ── Evening Punch Out / Exit ──
    if (
      activity.includes("punch_out") ||
      activity.includes("evening_punch") ||
      activity.includes("exit")
    )
      return makePin(
        "#ef4444",
        "#dc2626",
        `
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <polyline points="16 17 21 12 16 7" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <line x1="21" y1="12" x2="9" y2="12" stroke="#ef4444" stroke-width="2" stroke-linecap="round"/>
    `,
      );

    // ── Doctor Visit ──
    if (activity.includes("add_doctor_visit") || activity.includes("doctor"))
      return makePin(
        "#8b5cf6",
        "#7c3aed",
        `
      <path d="M12 2a5 5 0 0 1 5 5v3a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5z" stroke="#8b5cf6" stroke-width="2" fill="none"/>
      <path d="M12 15v2" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round"/>
      <path d="M7 17a5 5 0 0 0 10 0" stroke="#8b5cf6" stroke-width="2" fill="none" stroke-linecap="round"/>
      <circle cx="17" cy="17" r="2" fill="#8b5cf6"/>
      <line x1="10" y1="7" x2="14" y2="7" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round"/>
      <line x1="12" y1="5" x2="12" y2="9" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round"/>
    `,
      );

    // ── Chemist Visit ──
    if (activity.includes("chemist"))
      return makePin(
        "#ec4899",
        "#db2777",
        `
    <g transform="rotate(-35 12 12)">
      <rect x="5" y="9" width="14" height="6" rx="3" fill="#ec4899"/>
      <rect x="12" y="9" width="7" height="6" rx="3" fill="white"/>
    </g>
  `,
      );

    // ── Stockist Visit ──
    if (activity.includes("add_stockist_visit"))
      return makePin(
        "#f97316",
        "#ea580c",
        `
      <path d="M21 8L12 3 3 8v8l9 5 9-5V8z" stroke="#f97316" stroke-width="2" stroke-linejoin="round" fill="none"/>
      <polyline points="3 8 12 13 21 8" stroke="#f97316" stroke-width="2" stroke-linejoin="round" fill="none"/>
      <line x1="12" y1="13" x2="12" y2="22" stroke="#f97316" stroke-width="2"/>
    `,
      );

    // ── Last Call ──
    if (activity.includes("last_call"))
      return makePin(
        "#06b6d4",
        "#0891b2",
        `
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.37 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.12 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="#06b6d4" stroke-width="2" fill="none"/>
      <path d="M14.5 2a9.5 9.5 0 0 1 7.5 7.5" stroke="#06b6d4" stroke-width="2" stroke-linecap="round" fill="none"/>
      <path d="M14.5 6A5.5 5.5 0 0 1 18 9.5" stroke="#06b6d4" stroke-width="2" stroke-linecap="round" fill="none"/>
    `,
      );

    // ✅ NEW: Expense Visit — receipt icon (MUST be before generic visit)
    if (activity.includes("add_expense_visit"))
      return makePin(
        "#14b8a6",
        "#0d9488",
        `
      <rect x="5" y="3" width="14" height="18" rx="2" stroke="#14b8a6" stroke-width="2" fill="none"/>
      <line x1="9" y1="8"  x2="15" y2="8"  stroke="#14b8a6" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="9" y1="12" x2="15" y2="12" stroke="#14b8a6" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="9" y1="16" x2="12" y2="16" stroke="#14b8a6" stroke-width="1.5" stroke-linecap="round"/>
    `,
      );

    // ── Generic Visit ──
    if (activity.includes("visit"))
      return makePin(
        "#3b82f6",
        "#2563eb",
        `
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="#3b82f6" stroke-width="2" fill="none"/>
      <line x1="9" y1="3" x2="9" y2="21" stroke="#3b82f6" stroke-width="2"/>
      <line x1="15" y1="3" x2="15" y2="21" stroke="#3b82f6" stroke-width="2"/>
      <line x1="3" y1="9" x2="21" y2="9" stroke="#3b82f6" stroke-width="2"/>
      <line x1="3" y1="15" x2="21" y2="15" stroke="#3b82f6" stroke-width="2"/>
    `,
      );

    // ── Call Stop ──
    if (activity.includes("call_stop"))
      return makePin(
        "#6b7280",
        "#4b5563",
        `
      <line x1="1" y1="1" x2="23" y2="23" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/>
      <path d="M16.5 16.5l3.77 3.77a2 2 0 0 0 2.73-2.73l-3.77-3.77A9 9 0 0 0 4.73 4.73L1 1" stroke="#6b7280" stroke-width="2" fill="none" stroke-linecap="round"/>
    `,
      );

    // ── Generic Call ──
    if (activity.includes("call"))
      return makePin(
        "#3b82f6",
        "#2563eb",
        `
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.37 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.12 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="#3b82f6" stroke-width="2" fill="none"/>
    `,
      );

    // ── Default ──
    return makePin(
      "#6b7280",
      "#4b5563",
      `
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="#6b7280" stroke-width="2" fill="none"/>
    <circle cx="12" cy="9" r="2.5" fill="#6b7280"/>
  `,
    );
  };

  const isTravelActivity = (activityType) => {
    const activity = (activityType || "").toLowerCase();
    return (
      activity === "travel" ||
      activity === "" ||
      activity === "null" ||
      activity === "unknown" ||
      !activityType
    );
  };

  const clearMapElements = () => {
    markersRef.current.forEach((marker) => {
      try {
        if (marker && marker.setMap) marker.setMap(null);
      } catch (_) { }
    });
    markersRef.current = [];

    polylinesRef.current.forEach((p) => {
      try {
        if (p && p.setMap) p.setMap(null);
      } catch (_) { }
    });
    polylinesRef.current = [];

    if (animationMarkerRef.current) {
      try {
        animationMarkerRef.current.setMap(null);
      } catch (_) { }
      animationMarkerRef.current = null;
    }

    if (homeMarkerRef.current) {
      try {
        homeMarkerRef.current.setMap(null);
      } catch (_) { }
      homeMarkerRef.current = null;
    }
  };
const updateHomeAddress = async (lat, lng, resolvedAddress) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/employee/home-address/${employeeId}`,
      {
        method: "POST",
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          latitude:  lat,
          longitude: lng,
          address:   resolvedAddress || null,  
        }),
      }
    );
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const result = await response.json();
    console.log("✅ Home address updated:", result);
    return result;
  } catch (err) {
    console.error("❌ Failed to update home address:", err);
    throw err;
  }
};

  // ─── FETCH COMPARE LOCATIONS — untouched ───
  const fetchCompareLocations = async () => {
    setLoading(true);
    setError(null);
    try {
      const formattedDate = normalizeDateForApi(propDate);
      const url = `${BASE_URL}/api/employee/${employeeId}/compare-locations?track_date=${formattedDate}`;
      console.log("🔍 Fetching compare locations:", url);
      const response = await fetch(url, { headers: getAuthHeaders() });
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      console.log("✅ Compare locations received:", data);
      if (!cancelledRef.current)
        setCompareLocations(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("❌ Compare locations error:", err);
      if (!cancelledRef.current) {
        setError(err.message || "Failed to fetch compare locations");
        setCompareLocations([]);
      }
    } finally {
      if (!cancelledRef.current) setLoading(false);
    }
  };

  // ─── FETCH REGULAR LOCATIONS — only setLocationData logic changed for "expense" ───
  const fetchLocationData = async () => {
    setLoading(true);
    setError(null);
    try {
      const formattedDate = date
        ? new Date(date).toISOString().split("T")[0]
        : "";
      const url = `${BASE_URL}/api/employee/${employeeId}/locations${formattedDate ? `?track_date=${encodeURIComponent(formattedDate)}` : ""
        }${visitId ? `&visit_id=${encodeURIComponent(visitId)}` : ""}`;
      console.log("🔍 Fetching regular locations:", url);
      const response = await fetch(url, { headers: getAuthHeaders() });
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const jsonData = await response.json();
      console.log("✅ Regular locations received:", jsonData);

      const sortedData = Array.isArray(jsonData)
        ? jsonData.sort((a, b) => {
          const timeA = new Date(
            a.mobile_time || a.server_time || 0,
          ).getTime();
          const timeB = new Date(
            b.mobile_time || b.server_time || 0,
          ).getTime();
          return timeA - timeB;
        })
        : [];
      setFullDayLocations(sortedData);

      const filtered = sortedData.filter((loc) => {
        const activity = (loc.activity_type || "").toLowerCase();
        return !isTravelActivity(activity);
      });

      if (!cancelledRef.current) {
        // ─── punch contexts — unchanged ───
        if (
          (context === "morningPunch" || context === "eveningPunch") &&
          specificPunchTime
        ) {
          const targetTime = String(specificPunchTime).substring(0, 16);
          const matched = sortedData.reduce((closest, loc) => {
            const locTime = String(
              loc.mobile_time || loc.server_time || "",
            ).substring(0, 16);
            if (!closest) return loc;
            const closestTime = String(
              closest.mobile_time || closest.server_time || "",
            ).substring(0, 16);
            return Math.abs(locTime.localeCompare(targetTime)) <
              Math.abs(closestTime.localeCompare(targetTime))
              ? loc
              : closest;
          }, null);
          setLocationData(matched ? [matched] : sortedData.slice(0, 1));
          return;
        }

        if (locId) {
          const byId = filtered.filter(
            (l) =>
              String(l.id) === String(locId) ||
              String(l.location_id) === String(locId) ||
              String(l.locationId) === String(locId),
          );
          setLocationData(byId.length ? byId : filtered);
        } else if (context === "expense") {
          // ✅ EXPENSE: only show add_expense_visit points, hide everything else
          const expenseOnly = sortedData.filter((loc) =>
            (loc.activity_type || "").toLowerCase().includes("add_expense_visit")
          );
          setLocationData(expenseOnly);
        } else {
          setLocationData(sortedData);
          if (sortedData.length > 0) {
           setTotalDistance(
            sortedData[sortedData.length - 1]?.km_covered || 0
          );
          }
        }
      }
    } catch (err) {
      console.error("❌ Error fetching location data:", err);
      if (!cancelledRef.current) {
        setError(err.message || "Failed to fetch location data");
        setLocationData([]);
      }
    } finally {
      if (!cancelledRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchReady || !searchInputRef.current || !mapInstanceRef.current)
      return;
    if (!window.google?.maps?.places?.Autocomplete) {
      console.warn(
        "⚠️ Google Places library not loaded — add &libraries=places to your Maps URL",
      );
      return;
    }

    if (autocompleteRef.current) {
      window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      autocompleteRef.current = null;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
      { fields: ["geometry", "name", "formatted_address"] },
    );

    autocomplete.bindTo("bounds", mapInstanceRef.current);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place?.geometry?.location) return;

      const loc = place.geometry.location;

      if (place.geometry.viewport) {
        mapInstanceRef.current.fitBounds(place.geometry.viewport);
      } else {
        mapInstanceRef.current.setCenter(loc);
        mapInstanceRef.current.setZoom(15);
      }

      const searchMarker = new window.google.maps.Marker({
        position: loc,
        map: mapInstanceRef.current,
        title: place.name,
        icon: {
          url:
            "data:image/svg+xml;charset=UTF-8," +
            encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50">
      <ellipse cx="20" cy="48" rx="8" ry="3" fill="rgba(0,0,0,0.25)"/>
      <path d="M20 2 C10 2 2 10 2 20 C2 32 20 46 20 46 C20 46 38 32 38 20 C38 10 30 2 20 2 Z"
            fill="#f59e0b" stroke="#ffffff" stroke-width="2"/>
      <circle cx="18" cy="18" r="7" fill="none" stroke="#ffffff" stroke-width="2.5"/>
      <line x1="23" y1="23" x2="28" y2="28" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"/>
    </svg>
  `),
          scaledSize: new window.google.maps.Size(40, 50),
          anchor: new window.google.maps.Point(20, 50),
        },
        zIndex: 9999,
        optimized: false,
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `
        <div style="padding:10px;font-family:sans-serif;min-width:200px;">
          <div style="font-weight:700;font-size:14px;color:#f59e0b;margin-bottom:4px;">
            🔍 ${place.name}
          </div>
          <div style="font-size:12px;color:#6b7280;">${place.formatted_address || ""}</div>
        </div>
      `,
      });

      infoWindow.open(mapInstanceRef.current, searchMarker);
      searchMarker.addListener("click", () =>
        infoWindow.open(mapInstanceRef.current, searchMarker),
      );
      setTimeout(() => {
        try {
          searchMarker.setMap(null);
        } catch (_) { }
      }, 30000);
    });

    autocompleteRef.current = autocomplete;
  }, [searchReady, map]);

  useEffect(() => {
    cancelledRef.current = false;
    setLinearDistance(null);

    const setup = async () => {
      setLoading(true);
      setError(null);
      try {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        if (!apiKey)
          throw new Error(
            "Missing REACT_APP_GOOGLE_MAPS_API_KEY environment variable",
          );
        await loadGoogleMaps(apiKey);
        if (cancelledRef.current) return;
        setGoogleLoaded(true);

        if (context === "compare") {
          await fetchCompareLocations();
        } else if (context === "homeOnly") {
          console.log("🏠 Home only mode — skipping location API");
        } else {
          await fetchLocationData();
        }
      } catch (err) {
        console.error("Setup error:", err);
        if (!cancelledRef.current)
          setError("Failed to load maps: " + (err.message || err));
      } finally {
        if (!cancelledRef.current) setLoading(false);
      }
    };

    setup();

    return () => {
      cancelledRef.current = true;
      clearMapElements();
      if (animationRef.current) clearTimeout(animationRef.current);
    };
  }, [employeeId, date, locId, context]);

  // ─── Compare mode effect — untouched ───
  useEffect(() => {
    if (
      context !== "compare" ||
      !compareLocations ||
      compareLocations.length === 0 ||
      !isGoogleReady() ||
      !mapRef.current
    )
      return;

    clearMapElements();

    const googleMap = new window.google.maps.Map(mapRef.current, {
      zoom: 14,
      mapTypeId: mapType,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
    });

    mapInstanceRef.current = googleMap;
    setMap(googleMap);

    const bounds = new window.google.maps.LatLngBounds();

    const placeMarker = (point) => {
      const lat = Number(point.latitude);
      const lng = Number(point.longitude);
      if (isNaN(lat) || isNaN(lng)) return;

      const position = { lat, lng };
      bounds.extend(position);

      const role = getCompareRole(point.employee_type);
      const time = formatTimeTo12Hour(
        point.mobile_time || point.server_time
      );

      const svg = buildCompareMarkerSVG({
        role,
        time,
        bg: role === "SR" ? "#2563eb" : role === "IND" ? "#10b981" : "#dc2626",
      });

      const marker = new window.google.maps.Marker({
        draggable: true,
        position,
        map: googleMap,
        icon: {
          url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
          scaledSize: new window.google.maps.Size(90, 58),
          anchor: new window.google.maps.Point(45, 58),
        },
        optimized: false,
      });
      markersRef.current.push(marker);
    };

    compareLocations.forEach(placeMarker);

    if (!bounds.isEmpty()) googleMap.fitBounds(bounds);
  }, [context, compareLocations, mapType]);

  // ─── homeOnly effect — untouched ───
  useEffect(() => {
    if (
      context !== "homeOnly" ||
      !googleLoaded ||
      !isGoogleReady() ||
      !mapRef.current ||
      !residenceAddress
    )
      return;

    clearMapElements();

    const googleMap = new window.google.maps.Map(mapRef.current, {
      zoom: 15,
      mapTypeId: mapType,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
    });

    mapInstanceRef.current = googleMap;
    setMap(googleMap);

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: residenceAddress }, (results, status) => {
      if (status === "OK" && results[0]) {
        const loc = results[0].geometry.location;
        googleMap.setCenter(loc);

        const marker = new window.google.maps.Marker({
          draggable: true,
          position: loc,
          map: googleMap,
          title: "Home Address",
          icon: {
            url: homeMarker,
            scaledSize: new window.google.maps.Size(36, 36),
            anchor: new window.google.maps.Point(18, 36),
          },
        });
        homeMarkerRef.current = marker;

        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div style="padding:10px;font-family:sans-serif;">
              <strong>Home Address</strong>
              <div style="margin-top:6px;font-size:13px;">${residenceAddress}</div>
            </div>
          `,
        });

        marker.addListener("click", () => infoWindow.open(googleMap, marker));
      } else {
        console.warn("Geocode failed:", status);
      }
    });
  }, [context, mapType, residenceAddress, googleLoaded]); // eslint-disable-line react-hooks/exhaustive-deps
// ─── homeOnly effect ───
useEffect(() => {
  if (
    context !== "homeOnly" ||
    !googleLoaded ||
    !isGoogleReady() ||
    !mapRef.current ||
    !residenceAddress
  )
    return;

  clearMapElements();

  const googleMap = new window.google.maps.Map(mapRef.current, {
    zoom: 15,
    mapTypeId: mapType,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: true,
  });

  mapInstanceRef.current = googleMap;
  setMap(googleMap);

  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ address: residenceAddress }, (results, status) => {
    if (status === "OK" && results[0]) {
      const loc = results[0].geometry.location;
      googleMap.setCenter(loc);

      const marker = new window.google.maps.Marker({
        draggable: true,
        position: loc,
        map: googleMap,
        title: "Home Address",
        icon: {
          url: homeMarker,
          scaledSize: new window.google.maps.Size(36, 36),
          anchor: new window.google.maps.Point(18, 36),
        },
        zIndex: 3000,
        optimized: false,
      });
      homeMarkerRef.current = marker;

      const hwInfo = new window.google.maps.InfoWindow({
        content: `
          <div style="padding:10px;font-family:sans-serif;">
            <strong>🏠 Home Address</strong>
            <div style="margin-top:6px;font-size:13px;">${residenceAddress}</div>
          </div>
        `,
      });

      marker.addListener("click", () => hwInfo.open(googleMap, marker));
      hwInfo.open(googleMap, marker);

      // ✅ dragend is INSIDE the geocode callback — marker and hwInfo are in scope
      // ✅ UPDATED: dragend no longer auto-saves. It just reverse-geocodes and shows
      // a "Save" button — the update API only fires when the user clicks it, so we
      // don't hammer the backend on every drag.
      marker.addListener("dragend", () => {
        const pos = marker.getPosition();
        const lat = pos.lat();
        const lng = pos.lng();

        geocoder.geocode({ location: { lat, lng } }, (res, st) => {
          const resolvedAddress =
            st === "OK" && res[0] ? res[0].formatted_address : null;
          const displayAddress =
            resolvedAddress || `${lat.toFixed(6)}, ${lng.toFixed(6)}`;

          const bindSaveButton = () => {
            window.google.maps.event.addListenerOnce(hwInfo, "domready", () => {
              const btn = document.getElementById("home-address-save-btn");
              if (!btn) return;
              btn.addEventListener("click", async () => {
                btn.disabled = true;
                btn.textContent = "Saving...";
                try {
                  await updateHomeAddress(lat, lng, resolvedAddress);
                  hwInfo.setContent(`
                    <div style="padding:10px;font-family:sans-serif;min-width:220px;">
                      <strong>🏠 Home Address ✓</strong>
                      <div style="margin-top:6px;font-size:13px;">
                        ${displayAddress}
                      </div>
                      <div style="margin-top:4px;font-size:11px;color:#10b981;">Saved successfully</div>
                    </div>
                  `);
                  hwInfo.open(googleMap, marker);
                } catch {
                  hwInfo.setContent(`
                    <div style="padding:10px;font-family:sans-serif;min-width:220px;">
                      <strong>🏠 Home Address</strong>
                      <div style="margin-top:6px;font-size:13px;">
                        ${resolvedAddress || residenceAddress}
                      </div>
                      <div style="margin-top:4px;font-size:11px;color:#ef4444;">Save failed — try again</div>
                      <button id="home-address-save-btn" style="margin-top:8px;padding:6px 14px;background:#2563eb;color:#fff;border:none;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;">
                        Save
                      </button>
                    </div>
                  `);
                  hwInfo.open(googleMap, marker);
                  bindSaveButton();
                }
              });
            });
          };

          // Pending state: pin moved, address resolved, waiting for the user
          // to confirm with the Save button — nothing is sent to the server yet.
          hwInfo.setContent(`
            <div style="padding:10px;font-family:sans-serif;min-width:220px;">
              <strong>🏠 Home Address</strong>
              <div style="margin-top:6px;font-size:13px;">
                ${displayAddress}
              </div>
              <div style="margin-top:4px;font-size:11px;color:#9ca3af;">Pin moved — click Save to confirm</div>
              <button id="home-address-save-btn" style="margin-top:8px;padding:6px 14px;background:#2563eb;color:#fff;border:none;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;">
                Save
              </button>
            </div>
          `);
          hwInfo.open(googleMap, marker);
          bindSaveButton();
        });
      });

    } else {
      console.warn("Geocode failed:", status);
    }
  });
}, [context, mapType, residenceAddress, googleLoaded]); // eslint-disable-line react-hooks/exhaustive-deps
  const drawRoutes = async (locations, googleMap) => {
    if (!window.google?.maps?.DirectionsService) return;
    const directionsService = new window.google.maps.DirectionsService();
    const CHUNK_SIZE = 24;

    for (
      let chunkStart = 0;
      chunkStart < locations.length - 1;
      chunkStart += CHUNK_SIZE
    ) {
      const chunkEnd = Math.min(chunkStart + CHUNK_SIZE, locations.length - 1);
      const chunkLocations = locations.slice(chunkStart, chunkEnd + 1);
      if (chunkLocations.length < 2) continue;

      const origin = {
        lat: Number(chunkLocations[0].latitude),
        lng: Number(chunkLocations[0].longitude),
      };
      const destination = {
        lat: Number(chunkLocations[chunkLocations.length - 1].latitude),
        lng: Number(chunkLocations[chunkLocations.length - 1].longitude),
      };
      const waypoints = chunkLocations.slice(1, -1).map((loc) => ({
        location: { lat: Number(loc.latitude), lng: Number(loc.longitude) },
        stopover: false,
      }));

      try {
        await new Promise((resolve) => {
          directionsService.route(
            {
              origin,
              destination,
              waypoints,
              travelMode: window.google.maps.TravelMode.DRIVING,
              optimizeWaypoints: false,
            },
            (result, status) => {
              if (status === "OK" && result) {
                const polyline = new window.google.maps.Polyline({
                  path: result.routes[0].overview_path,
                  geodesic: true,
                  // strokeColor: "#2563eb",
                  strokeColor: "#ef4444",
                  strokeOpacity: 0.85,
                  strokeWeight: 4,
                  zIndex: 60,
                });
                polyline.setMap(googleMap);
                polylinesRef.current.push(polyline);
              } else {
                for (let i = 0; i < chunkLocations.length - 1; i++) {
                  const lat1 = Number(chunkLocations[i].latitude);
                  const lng1 = Number(chunkLocations[i].longitude);
                  const lat2 = Number(chunkLocations[i + 1].latitude);
                  const lng2 = Number(chunkLocations[i + 1].longitude);
                  if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2))
                    continue;
                  const line = new window.google.maps.Polyline({
                    path: [
                      { lat: lat1, lng: lng1 },
                      { lat: lat2, lng: lng2 },
                    ],
                    geodesic: true,
                    // strokeColor: "#2563eb",
                    strokeColor: "#ef4444",
                    strokeOpacity: 0.6,
                    strokeWeight: 3,
                    zIndex: 40,
                  });
                  line.setMap(googleMap);
                  polylinesRef.current.push(line);
                }
              }
              resolve();
            },
          );
        });
        await new Promise((r) => setTimeout(r, 150));
      } catch (err) {
        console.warn("Route chunk error:", err);
      }
    }
  };

  // ─── EFFECT 4: Single mode map ───
  // ✅ "expense" context is now allowed through (not in the skip list)
  useEffect(() => {
    if (
      context === "compare" ||
      context === "homeOnly" ||
      context === "morningPunch" ||
      context === "eveningPunch" ||
      !locationData ||
      locationData.length === 0 ||
      !googleLoaded ||
      !isGoogleReady() ||
      !mapRef.current
    )
      return;

    console.log(
      "🗺️ Rendering single location map with",
      locationData.length,
      "locations",
    );

    clearMapElements();

    try {
      const firstLocation = locationData[0];
      const centerLat = Number(firstLocation.latitude);
      const centerLng = Number(firstLocation.longitude);

      if (isNaN(centerLat) || isNaN(centerLng))
        throw new Error("Invalid coordinates in first location");

      const googleMap = new window.google.maps.Map(mapRef.current, {
        zoom: 13,
        center: { lat: centerLat, lng: centerLng },
        mapTypeId: mapType,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
      });

      mapInstanceRef.current = googleMap;
      setMap(googleMap);

      const bounds = new window.google.maps.LatLngBounds();

      locationData.forEach((location, index) => {
        const lat = Number(location.latitude);
        const lng = Number(location.longitude);
        if (isNaN(lat) || isNaN(lng)) return;

        const position = { lat, lng };
        bounds.extend(position);

        const activity = (location.activity_type || "").toLowerCase();
        const isTravel = isTravelActivity(activity);
        const activityColor = getActivityColor(activity);
        const activityLabel = getActivityLabel(activity);

        const isFirstPoint = index === 0;
        const isLastPoint = index === locationData.length - 1;
        const scale = isFirstPoint || isLastPoint ? 21 : 17;

        const marker = new window.google.maps.Marker({
          draggable: true,
          position,
          map: googleMap,
          icon: isTravel
            ? {
              path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 5,
              fillColor: "#dceb0e",
              fillOpacity: 1,
              strokeColor: "#374151",
              strokeWeight: 1,
              rotation: location.heading || 0,
            }
            : getActivityMarkerIcon(location.activity_type, scale),
          label: isTravel
            ? {
              text: formatTimeTo12Hour(location.server_time),
              color: "#111827",
              fontSize: "11px",
              fontWeight: "600",
              className: "map-label",
            }
            : undefined,
          zIndex: 2000,
          optimized: false,
        });

        const infoContent = `
  <div style="padding:14px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;max-width:320px;">
    <div style="font-weight:700;font-size:17px;color:${activityColor};margin-bottom:10px;display:flex;align-items:center;gap:8px;">
      ${getActivityIcon(activity)} ${activityLabel}
    </div>
    <div style="font-size:14px;color:#1f2937;line-height:1.7;">

      <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
        <strong style="color:#6b7280;">Date:</strong>
        <span style="font-weight:500;">${formatDate(location.mobile_time)}</span>
      </div>

      ${location.doctor_name ? `
        <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
          <strong style="color:#6b7280;">🏥 Doctor:</strong>
          <span style="font-weight:600;color:#8b5cf6;">${location.doctor_name}</span>
        </div>` : ""}

      ${location.call_name && !location.doctor_name ? `
        <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
          <strong style="color:#6b7280;">${activity.includes("chemist") ? "💊 Chemist:" :
              activity.includes("stockist") ? "📦 Stockist:" : "📋 Visit:"
            }</strong>
          <span style="font-weight:600;color:${activity.includes("chemist") ? "#ec4899" :
              activity.includes("stockist") ? "#f97316" : "#3b82f6"
            };">${location.call_name}</span>
        </div>` : ""}


      ${location.area_name ? `
        <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
          <strong style="color:#6b7280;">📍 Area:</strong>
          <span style="font-weight:500;color:#059669;">${location.area_name}</span>
        </div>` : ""}

      <div style="margin-bottom:6px;">
        <div style="margin-top:4px;">
          <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
            <strong style="color:#6b7280;">Visit Time:</strong>
            <span style="font-weight:500;">${formatTimeTo12Hour(location.mobile_time)}</span>
          </div>
          <div style="border-top:1px solid #e5e7eb;margin:4px 0;"></div>
          <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
            <strong style="color:#6b7280;">Server Time:</strong>
            <span style="font-weight:500;">${formatTimeTo12Hour(location.server_time)}</span>
          </div>
        </div>
      </div>

      <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
        <strong style="color:#6b7280;">Activity:</strong>
        <span style="font-weight:500;">${formatActivityType(location.activity_type)}</span>
      </div>
      <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
        <strong style="color:#6b7280;">Distance:</strong>
        <span style="font-weight:500;">${(location.distance_km || 0).toFixed(2)} km</span>
      </div>
      <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
        <strong style="color:#6b7280;">Total Distance:</strong>
        <span style="font-weight:500;color:#3b82f6;">${(location.km_covered || 0).toFixed(2)} km</span>
      </div>
      <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
        <strong style="color:#6b7280;">Speed:</strong>
        <span style="font-weight:500;">${(location.speed || 0).toFixed(1)} m/s</span>
      </div>
      <div style="margin-bottom:6px;display:flex;justify-content:space-between;">
        <strong style="color:#6b7280;">Accuracy:</strong>
        <span style="font-weight:500;">${(location.accuracy_meter || 0).toFixed(1)} m</span>
      </div>

      ${location.address ? `
        <div style="margin-top:10px;padding-top:10px;border-top:1px solid #e5e7eb;">
          <strong style="color:#6b7280;">Location:</strong>
          <div style="margin-top:4px;font-weight:500;">${location.address}</div>
        </div>` : ""}

      <div style="margin-top:10px;padding-top:10px;border-top:1px solid #e5e7eb;font-size:12px;color:#9ca3af;">
        ${lat.toFixed(6)}, ${lng.toFixed(6)}
      </div>
    </div>
  </div>
`;

        const infoWindow = new window.google.maps.InfoWindow({
          content: infoContent,
        });

        marker.activityType = activity;
        marker.locationData = location;
        marker._infoWindow = infoWindow;

        marker.addListener("click", () => {
          infoWindow.open(googleMap, marker);
          setSelectedLocation(location);
        });

        markersRef.current.push(marker);
      });

      // ✅ EXPENSE: skip route drawing entirely — each expense visit is independent
      if (context === "expense") {
        // No connecting lines between expense visit points
      } else {
        const nonTravelPoints = locationData.filter(
          (loc) => !isTravelActivity(loc.activity_type),
        );
        const routePoints =
          nonTravelPoints.length >= 2
            ? locationData
            : locationData;
        if (routePoints.length >= 2) {
          drawRoutes(routePoints, googleMap);
        } else {
          for (let i = 0; i < locationData.length - 1; i++) {
            const lat1 = Number(locationData[i].latitude);
            const lng1 = Number(locationData[i].longitude);
            const lat2 = Number(locationData[i + 1].latitude);
            const lng2 = Number(locationData[i + 1].longitude);
            if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2))
              continue;
            const line = new window.google.maps.Polyline({
              path: [
                { lat: lat1, lng: lng1 },
                { lat: lat2, lng: lng2 },
              ],
              geodesic: true,
              strokeColor: "#ef4444",
              strokeOpacity: 0.7,
              strokeWeight: 3,
              icons: [
                {
                  icon: { path: "M 0,-1 0,1", strokeOpacity: 1, scale: 6 },
                  offset: "0",
                  repeat: "20px",
                },
              ],
              zIndex: 40,
            });
            line.setMap(googleMap);
            polylinesRef.current.push(line);
          }
        }
      }

      if (!bounds.isEmpty()) {
        googleMap.fitBounds(bounds);
        setTimeout(() => {
          if (mapInstanceRef.current) {
            const currentZoom = mapInstanceRef.current.getZoom();
            if (currentZoom > 15) mapInstanceRef.current.setZoom(15);
          }
        }, 300);
      }

      // ─── Home marker logic — untouched ───
      const addrEntry = locationData.find(
        (l) => l.employee_address && typeof l.employee_address === "string",
      );
      const addressString = addrEntry
        ? String(addrEntry.employee_address).trim()
        : null;

      if (addressString && isGoogleReady() && googleMap) {
        const geocoder = new window.google.maps.Geocoder();
        const cacheKey = `geocode:${addressString}`;

        const tryPlaceHome = (latLng) => {
          try {
            if (homeMarkerRef.current) {
              try {
                homeMarkerRef.current.setMap(null);
              } catch (_) { }
              homeMarkerRef.current = null;
            }

            const hm = new window.google.maps.Marker({
              position: { lat: latLng.lat, lng: latLng.lng },
              map: googleMap,
              title: "Home Address",
              icon: {
                url: homeMarker,
                size: new window.google.maps.Size(48, 48),
                scaledSize: new window.google.maps.Size(36, 36),
                anchor: new window.google.maps.Point(18, 36),
              },
              zIndex: 3000,
              optimized: false,
            });

            homeMarkerRef.current = hm;

            const hwInfo = new window.google.maps.InfoWindow({
              content: `<div style="padding:10px;font-family:sans-serif;"><strong>Home Address</strong><div style="margin-top:6px;font-size:13px;">${addressString}</div></div>`,
            });

            hm.addListener("click", () => hwInfo.open(googleMap, hm));

            try {
              const latLngObj = new window.google.maps.LatLng(
                latLng.lat,
                latLng.lng,
              );
              bounds.extend(latLngObj);
              googleMap.fitBounds(bounds);
              setTimeout(() => {
                if (mapInstanceRef.current) {
                  const currentZoom = mapInstanceRef.current.getZoom();
                  if (currentZoom > 15) mapInstanceRef.current.setZoom(15);
                }
              }, 300);
            } catch (e) { }
          } catch (e) {
            console.warn("placeHome marker error:", e);
          }
        };

        let cached = null;
        try {
          const mem = cacheRef.current.get(cacheKey);
          if (
            mem &&
            mem.lat &&
            mem.lng &&
            mem.ts &&
            Date.now() - mem.ts < 7 * 24 * 60 * 60 * 1000
          ) {
            cached = mem;
          } else if (mem) {
            cacheRef.current.delete(cacheKey);
          }
        } catch (e) {
          cached = null;
        }

        if (!cached && USE_SESSION_FALLBACK) {
          try {
            const raw = sessionStorage.getItem(cacheKey);
            if (raw) {
              const parsed = JSON.parse(raw);
              if (
                parsed &&
                parsed.lat &&
                parsed.lng &&
                parsed.ts &&
                Date.now() - parsed.ts < 7 * 24 * 60 * 60 * 1000
              ) {
                cached = parsed;
                try {
                  cacheRef.current.set(cacheKey, parsed);
                } catch (e) { }
              } else {
                try {
                  sessionStorage.removeItem(cacheKey);
                } catch (e) { }
              }
            }
          } catch (e) {
            cached = null;
          }
        }

        if (cached) {
          tryPlaceHome({ lat: cached.lat, lng: cached.lng });
        } else {
          geocodeAddress(geocoder, addressString)
            .then((res) => {
              try {
                const payload = { lat: res.lat, lng: res.lng, ts: Date.now() };
                try {
                  cacheRef.current.set(cacheKey, payload);
                } catch (e) { }
                if (USE_SESSION_FALLBACK) {
                  try {
                    sessionStorage.setItem(cacheKey, JSON.stringify(payload));
                  } catch (e) { }
                }
              } catch (e) { }
              tryPlaceHome({ lat: res.lat, lng: res.lng });
            })
            .catch((err) =>
              console.warn("Geocode failed for employee_address:", err),
            );
        }
      }
    } catch (err) {
      console.error("Error creating map:", err);
      setError(err.message || "Failed to create map");
    }
  }, [context, locationData, mapType, googleLoaded]);

  // ─── Punch mode effect — untouched ───
  useEffect(() => {
    if (
      (context !== "morningPunch" && context !== "eveningPunch") ||
      !locationData ||
      locationData.length === 0 ||
      !googleLoaded ||
      !isGoogleReady() ||
      !mapRef.current
    )
      return;

    console.log("📍 Rendering punch-only map for", context);

    clearMapElements();
    setLinearDistance(null);

    const punchLocation = locationData[0];
    const punchLat = Number(punchLocation.latitude);
    const punchLng = Number(punchLocation.longitude);

    if (isNaN(punchLat) || isNaN(punchLng)) {
      setError("Invalid punch coordinates");
      return;
    }

    const isMorning = context === "morningPunch";

    const googleMap = new window.google.maps.Map(mapRef.current, {
      zoom: 13,
      center: { lat: punchLat, lng: punchLng },
      mapTypeId: mapType,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControl: true,
    });

    mapInstanceRef.current = googleMap;
    setMap(googleMap);

    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend({ lat: punchLat, lng: punchLng });

    const punchMarker = new window.google.maps.Marker({
      position: { lat: punchLat, lng: punchLng },
      map: googleMap,
      title: isMorning ? "Morning Punch In" : "Evening Punch Out",
      icon: {
        url: isMorning ? punchInIcon : punchExitIcon,
        scaledSize: new window.google.maps.Size(52, 52),
        anchor: new window.google.maps.Point(26, 52),
      },
      zIndex: 3000,
      optimized: false,
    });
    markersRef.current.push(punchMarker);

    const punchTime = formatTimeTo12Hour(
      punchLocation.mobile_time || punchLocation.server_time,
    );

    const punchInfo = new window.google.maps.InfoWindow({
      content: `
        <div style="padding:12px;font-family:sans-serif;min-width:220px;">
          <div style="font-weight:700;font-size:15px;color:${isMorning ? "#f59e0b" : "#3b82f6"};margin-bottom:8px;">
            ${isMorning ? "🌅 Morning Punch In" : "🌙 Evening Punch Out"}
          </div>
          <div style="font-size:13px;color:#1f2937;line-height:1.8;">
            <div><strong>Time:</strong> ${punchTime}</div>
            ${punchLocation.address ? `<div style="margin-top:6px;"><strong>Location:</strong><br/>${punchLocation.address}</div>` : ""}
            <div style="margin-top:4px;font-size:11px;color:#9ca3af;">${punchLat.toFixed(6)}, ${punchLng.toFixed(6)}</div>
          </div>
        </div>
      `,
    });

    punchMarker.addListener("click", () =>
      punchInfo.open(googleMap, punchMarker),
    );
    punchInfo.open(googleMap, punchMarker);
    setSelectedLocation(punchLocation);

    const addrString =
      residenceAddress ||
      (punchLocation.employee_address
        ? String(punchLocation.employee_address).trim()
        : null);

    if (addrString && isGoogleReady()) {
      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ address: addrString }, (results, status) => {
        if (status !== "OK" || !results[0]) {
          console.warn("Geocode failed for home address:", status);
          return;
        }

        const homeLoc = results[0].geometry.location;
        const homeLat = homeLoc.lat();
        const homeLng = homeLoc.lng();

        const hm = new window.google.maps.Marker({
          position: { lat: homeLat, lng: homeLng },
          map: googleMap,
          title: "Home Address",
          icon: {
            url: homeMarker,
            scaledSize: new window.google.maps.Size(36, 36),
            anchor: new window.google.maps.Point(18, 36),
          },
          zIndex: 3000,
          optimized: false,
        });
        homeMarkerRef.current = hm;

        const homeInfo = new window.google.maps.InfoWindow({
          content: `
            <div style="padding:10px;font-family:sans-serif;">
              <strong>🏠 Home Address</strong>
              <div style="margin-top:6px;font-size:13px;">${addrString}</div>
            </div>
          `,
        });
        hm.addListener("click", () => homeInfo.open(googleMap, hm));

        const connectingLine = new window.google.maps.Polyline({
          path: [
            { lat: punchLat, lng: punchLng },
            { lat: homeLat, lng: homeLng },
          ],
          geodesic: true,
          strokeColor: "#ef4444",
          strokeOpacity: 1.0,
          strokeWeight: 2,
        });
        connectingLine.setMap(googleMap);
        polylinesRef.current.push(connectingLine);

        const R = 6371;
        const dLat = ((homeLat - punchLat) * Math.PI) / 180;
        const dLng = ((homeLng - punchLng) * Math.PI) / 180;
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos((punchLat * Math.PI) / 180) *
          Math.cos((homeLat * Math.PI) / 180) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
        const distKm = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        if (!cancelledRef.current) {
          setLinearDistance({
            km: distKm.toFixed(2),
            label: isMorning
              ? "Home Location and Morning Punch Location"
              : "Home Location and Evening Punch Location",
          });
        }

        bounds.extend({ lat: homeLat, lng: homeLng });
        googleMap.fitBounds(bounds);
        setTimeout(() => {
          if (mapInstanceRef.current) {
            const z = mapInstanceRef.current.getZoom();
            if (z > 14) mapInstanceRef.current.setZoom(14);
          }
        }, 300);
      });
    }
  }, [context, locationData, mapType, residenceAddress, googleLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── EFFECT 5: Sync mapType — untouched ───
  useEffect(() => {
    if (mapInstanceRef.current && isGoogleReady()) {
      try {
        mapInstanceRef.current.setMapTypeId(mapType);
      } catch (_) { }
    }
  }, [mapType]);

  // ─── Animation — untouched ───
  const startAnimation = () => {
    if (
      context === "compare" ||
      !mapInstanceRef.current ||
      locationData.length === 0 ||
      isAnimating ||
      !isGoogleReady()
    )
      return;

    setIsAnimating(true);
    setAnimationIndex(0);

    if (animationMarkerRef.current) {
      try {
        animationMarkerRef.current.setMap(null);
      } catch (_) { }
    }

    const newAnimationMarker = new window.google.maps.Marker({
      map: mapInstanceRef.current,
      icon: {
        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 6,
        fillColor: "#ef4444",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        rotation: 0,
      },
      zIndex: 2000,
      optimized: false,
    });

    animationMarkerRef.current = newAnimationMarker;
    animateMovement(newAnimationMarker, 0);
  };

  const animateMovement = (marker, index) => {
    if (index >= locationData.length) {
      setIsAnimating(false);
      return;
    }

    const location = locationData[index];
    const position = {
      lat: Number(location.latitude),
      lng: Number(location.longitude),
    };

    try {
      marker.setPosition(position);
      if (mapInstanceRef.current) mapInstanceRef.current.panTo(position);

      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding:10px;font-family:sans-serif;">
            <div style="font-weight:700;color:#ef4444;margin-bottom:6px;">${getActivityIcon(location.activity_type)} ${getActivityLabel(location.activity_type)}</div>
            <div style="font-size:13px;">
              <div><strong>Date:</strong> ${formatDate(location.mobile_time)}</div>
              <div><strong>Distance:</strong> ${(location.distance_km || 0).toFixed(2)} km</div>
            </div>
          </div>
        `,
      });

      infoWindow.open(mapInstanceRef.current, marker);
      setAnimationIndex(index);
      setSelectedLocation(location);
      setTimeout(() => {
        try {
          infoWindow.close();
        } catch (_) { }
      }, 2000);
    } catch (err) {
      console.warn("animateMovement step error:", err);
    }

    animationRef.current = setTimeout(
      () => animateMovement(marker, index + 1),
      1500,
    );
  };

  const pauseAnimation = () => {
    setIsAnimating(false);
    if (animationRef.current) clearTimeout(animationRef.current);
  };

  const resetAnimation = () => {
    pauseAnimation();
    setAnimationIndex(0);
    if (animationMarkerRef.current) {
      try {
        animationMarkerRef.current.setMap(null);
      } catch (_) { }
      animationMarkerRef.current = null;
    }
    setSelectedLocation(null);
  };

  const summaryStats = React.useMemo(() => {
    if (context === "compare" || !locationData || locationData.length === 0)
      return null;

    const punchIn = locationData.find(
      (l) =>
        (l.activity_type || "").toLowerCase().includes("punch_in") ||
        (l.activity_type || "").toLowerCase().includes("morning_punch"),
    );

    const punchOut = locationData.find(
      (l) =>
        (l.activity_type || "").toLowerCase().includes("punch_out") ||
        (l.activity_type || "").toLowerCase().includes("evening_punch"),
    );

    const visits = locationData.filter((l) => {
      const activity = (l.activity_type || "").toLowerCase();
      return (
        activity.includes("visit") ||
        activity.includes("doctor") ||
        activity.includes("chemist") ||
        activity.includes("stockist") ||
        activity.includes("call")
      );
    }).length;

    const totalDistance =
      locationData.length > 0
        ? Number(locationData[locationData.length - 1].km_covered || 0)
        : 0;

    return {
      punchIn,
      punchOut,
      visits,
      totalDistance,
      totalPoints: locationData.length,
    };
  }, [context, locationData]);

  const punchHeaderTimes = React.useMemo(() => {
    if (!locationData || fullDayLocations.length === 0) {
      return {
        morningPunch: null,
        eveningPunch: null,
        firstCall: null,
        lastCall: null,
      };
    }
    const sorted = [...fullDayLocations].sort(
      (a, b) =>
        new Date(a.server_time).getTime() - new Date(b.server_time).getTime(),
    );

    const morningPunch = sorted.find((l) =>
      (l.activity_type || "").toLowerCase().includes("morning_punch"),
    );

    const eveningPunch = sorted.find((l) =>
      (l.activity_type || "").toLowerCase().includes("evening_punch"),
    );

    const calls = sorted.filter((l) => {
      const type = (l.activity_type || "").toLowerCase();
      return type.includes("call") && !type.includes("punch");
    });

    return {
      morningPunch: morningPunch?.server_time || null,
      eveningPunch: eveningPunch?.server_time || null,
      firstCall: calls[0]?.server_time || null,
      lastCall: calls[calls.length - 1]?.server_time || null,
    };
  }, [fullDayLocations]);

  const focusOnActivity = (keyword) => {
    if (context === "compare") return;
    try {
      if (
        !mapInstanceRef.current ||
        !markersRef.current ||
        markersRef.current.length === 0
      )
        return;

      const key = (keyword || "").toLowerCase();
      const matched = markersRef.current.filter((m) => {
        const at = (m.activityType || "").toLowerCase();
        return at.includes(key);
      });

      if (!matched || matched.length === 0) {
        const loose = markersRef.current.filter((m) => {
          const at = (m.activityType || "").toLowerCase();
          return (
            (key === "punch" && at.includes("punch")) ||
            (key === "visit" && (at.includes("visit") || at.includes("call")))
          );
        });
        if (loose && loose.length > 0) {
          panToMarkers(loose);
          openMarkerInfo(loose[0]);
        } else {
          console.info("No markers found for:", key);
        }
        return;
      }

      panToMarkers(matched);
      openMarkerInfo(matched[0]);
    } catch (e) {
      console.warn("focusOnActivity error", e);
    }
  };

  const panToMarkers = (markerList) => {
    if (
      !markerList ||
      markerList.length === 0 ||
      !mapInstanceRef.current ||
      !isGoogleReady()
    )
      return;

    if (markerList.length === 1) {
      try {
        const pos = markerList[0].getPosition
          ? markerList[0].getPosition()
          : null;
        if (pos) {
          mapInstanceRef.current.panTo({ lat: pos.lat(), lng: pos.lng() });
          mapInstanceRef.current.setZoom(
            Math.max(mapInstanceRef.current.getZoom(), 15),
          );
        }
      } catch (_) { }
      return;
    }

    try {
      const bounds = new window.google.maps.LatLngBounds();
      markerList.forEach((m) => {
        try {
          const pos = m.getPosition ? m.getPosition() : null;
          if (pos) bounds.extend(pos);
        } catch (_) { }
      });
      mapInstanceRef.current.fitBounds(bounds);
      setTimeout(() => {
        try {
          if (mapInstanceRef.current) {
            const currentZoom = mapInstanceRef.current.getZoom();
            if (currentZoom > 15) mapInstanceRef.current.setZoom(15);
          }
        } catch (_) { }
      }, 250);
    } catch (e) {
      console.warn("panToMarkers fitBounds failed", e);
    }
  };

  const openMarkerInfo = (marker) => {
    if (!marker || !mapInstanceRef.current) return;
    try {
      if (marker._infoWindow) {
        marker._infoWindow.open(mapInstanceRef.current, marker);
        setSelectedLocation(marker.locationData || null);
      } else {
        window.google.maps.event.trigger(marker, "click");
      }
    } catch (e) {
      console.warn("openMarkerInfo error", e);
    }
  };

  const handleClose = () => {
    if (typeof onClose === "function") onClose();
    else navigate(-1);
  };

  const handleRefresh = () => {
    if (context === "compare") fetchCompareLocations();
    else if (context !== "homeOnly") fetchLocationData();
  };

  const outerClass = isModal
    ? "flex flex-col h-full w-full"
    : "bg-gradient-to-br from-gray-50 to-blue-50 p-4";
  const innerContainerClass = isModal
    ? "flex flex-col flex-1 overflow-hidden"
    : "max-w-7xl mx-auto";

  if (loading) {
    return (
      <div className={`${outerClass} items-center justify-center`}>
        <div className="text-center bg-white p-6 rounded-2xl shadow-lg">
          <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600 mx-auto mb-3" />
          <p className="text-lg text-gray-700 font-semibold">
            Loading Map Tracker...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`${outerClass} items-center justify-center p-4`}>
        <div className="text-center p-6 bg-white rounded-2xl shadow-lg border-2 border-red-100 max-w-lg">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-3" />
          <h3 className="text-xl font-bold text-gray-800 mb-2">
            Unable to Load Map
          </h3>
          <p className="text-gray-600 mb-4">{error}</p>
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={handleRefresh}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Try Again
            </button>
            <button
              onClick={handleClose}
              className="px-4 py-2 bg-gray-200 rounded-lg"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!loading && !error && locationData.length === 0 && context !== "compare" && context !== "homeOnly") {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="relative text-center p-6 bg-white rounded-2xl shadow-lg">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
          >
            <X className="h-4 w-4" />
          </button>
          <MapPin className="h-12 w-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-bold text-gray-600">No Location Data</h3>
          <p className="text-gray-400 text-sm mt-1">
            No tracking data found for this date.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={outerClass}>
      <div className={innerContainerClass}>
        {/* Header */}
        <div
          className={
            isModal
              ? "flex items-center justify-between gap-4 p-3 border-b bg-white"
              : "bg-white rounded-t-2xl shadow-lg p-6 border-b-2 border-blue-100"
          }
        >
          <div className="flex items-center gap-4">
            <div className="p-2 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-sm">
              <Navigation className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="font-bold text-gray-800 text-sm md:text-lg">
                {context === "compare"
                  ? "Compare Employee Locations"
                  : context === "expense"
                    ? "Expense Visit Locations" // ✅ custom title for expense
                    : "Employee Movement Tracker"}
              </h1>
              <p className="text-xs text-gray-500 mt-0.5">
                {employeeName && `${employeeName} • `}
                {date && formatDate(new Date(date), "DD MMM YYYY")}
                {context === "compare" && compareLocations.length > 0 && (
                  <span className="ml-2 text-blue-600">
                    ({compareLocations.length} comparison points)
                  </span>
                )}
                {context !== "compare" && locationData.length > 0 && (
                  <span className="ml-2 text-teal-600">
                    ({locationData.length} expense visit{locationData.length !== 1 ? "s" : ""})
                  </span>
                )}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={handleRefresh}
              className="flex items-center gap-2 px-3 py-1.5 bg-white border rounded-lg shadow-sm text-sm hover:bg-gray-50"
            >
              <RefreshCw className="h-4 w-4" /> Refresh
            </button>
            <button
              onClick={() =>
                setMapType((prev) =>
                  prev === "roadmap" ? "satellite" : "roadmap",
                )
              }
              className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg text-sm hover:from-blue-600 hover:to-indigo-700"
            >
              <Layers className="h-4 w-4" />{" "}
              {mapType === "roadmap" ? "Satellite" : "Map"}
            </button>
            <button
              onClick={handleClose}
              className="flex items-center gap-2 px-3 py-1.5 bg-red-500 text-white rounded-lg text-sm hover:bg-red-600"
            >
              <XIcon className="h-4 w-4" /> Close
            </button>
          </div>
        </div>

        {/* ─── Route & Location info bar ─── */}
        {context === "viewMap" &&
          (routeName || latestLocation || gpsStop || locationCount > 0) && (
            <div className="flex flex-wrap items-center gap-x-6 gap-y-1 px-4 py-2 bg-indigo-950 text-white text-xs border-b border-indigo-800">
              {punchHeaderTimes.morningPunch && (
                <div className="flex items-center gap-1.5">
                  <span className="text-white-700">Punch In:</span>
                  <span className="font-semibold text-yellow-300">
                    {formatTimeTo12Hour(punchHeaderTimes.morningPunch)}
                  </span>
                </div>
              )}
              {punchHeaderTimes.firstCall && (
                <div className="flex items-center gap-1.5">
                  <span className="text-white-700">First Call:</span>
                  <span className="font-semibold text-green-300">
                    {formatTimeTo12Hour(punchHeaderTimes.firstCall)}
                  </span>
                </div>
              )}
              {latestLocation && (
                <div className="flex items-center gap-1.5 min-w-0">
                  <span className="text-white-700 shrink-0">Location Found -</span>
                  <span
                    className="font-semibold text-yellow-200 truncate max-w-[180px]"
                    title={latestLocation}
                  >
                    {latestLocation}
                  </span>
                  <span className="text-white-700 shrink-0"> on </span>
                  <span className="font-semibold text-yellow-200">
                    {gpsStopIdleTime}
                  </span>
                </div>
              )}
              {routeName && (
                <div className="flex items-center gap-1.5 min-w-0">
                  <span className="text-white-700 shrink-0">Route Filled- </span>
                  <span
                    className="font-semibold text-green-200 truncate max-w-[160px]"
                    title={routeName}
                  >
                    {routeName}
                  </span>
                </div>
              )}
              {punchHeaderTimes.lastCall && (
                <div className="flex items-center gap-1.5">
                  <span className="text-white-700">Last Call:</span>
                  <span className="font-semibold text-blue-300">
                    {formatTimeTo12Hour(punchHeaderTimes.lastCall)}
                  </span>
                </div>
              )}
              {punchHeaderTimes.eveningPunch && (
                <div className="flex items-center gap-1.5">
                  <img
                    src={punchExitIcon}
                    alt="punch-exit"
                    className="w-4 h-4 object-contain opacity-90"
                  />
                  <span className="text-white-700">Punch Out:</span>
                  <span className="font-semibold text-red-300">
                    {formatTimeTo12Hour(punchHeaderTimes.eveningPunch)}
                  </span>
                </div>
              )}
            </div>
          )}

        {/* ─── Punch info header bar ─── */}
        {(context === "morningPunch" || context === "eveningPunch") && (
          <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2 bg-gray-900 text-white text-xs">
            <div className="flex items-center gap-2">
              <img
                src={punchInIcon}
                alt="punch-in"
                className="w-6 h-6 object-contain"
              />
              <span>
                <span className="text-gray-400">Punch In Time </span>
                <span className="font-semibold text-yellow-300">
                  {formatTimeTo12Hour(punchHeaderTimes.morningPunch) || "-"}
                </span>
              </span>
            </div>
            <div className="text-center">
              <span className="text-gray-400">First Call Time </span>
              <span className="font-semibold text-green-300">
                {formatTimeTo12Hour(punchHeaderTimes.firstCall) || "-"}
              </span>
            </div>
            <div className="text-center">
              <span className="text-gray-400">Last Call Time </span>
              <span className="font-semibold text-blue-300">
                {formatTimeTo12Hour(punchHeaderTimes.lastCall) || "-"}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <img
                src={punchExitIcon}
                alt="punch-exit"
                className="w-6 h-6 object-contain"
              />
              <span>
                <span className="text-gray-400">Punch Exit Time </span>
                <span className="font-semibold text-red-300">
                  {formatTimeTo12Hour(punchHeaderTimes.eveningPunch) || "-"}
                </span>
              </span>
            </div>
          </div>
        )}

        {/* Map area */}
        <div className="flex-1 flex flex-col min-h-0 overflow-hidden bg-white relative">
          {/* Search Bar */}
          {isGoogleReady() && map && (
            <div
              style={{
                position: "absolute",
                top: "12px",
                left: "50%",
                marginLeft: "-200px",
                zIndex: 9999,
                width: "400px",
                maxWidth: "calc(90% - 20px)",
              }}
            >
              <div className="flex items-center bg-white rounded-xl shadow-lg border border-gray-200 px-3 py-2 gap-2">
                <Search className="h-4 w-4 text-gray-400 shrink-0" />
                <input
                  ref={(el) => {
                    searchInputRef.current = el;
                    if (el && !searchReady) setSearchReady(true);
                  }}
                  type="text"
                  placeholder="Search location on map..."
                  className="flex-1 text-sm text-gray-700 placeholder-gray-400 outline-none bg-transparent"
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button
                    onClick={() => {
                      setSearchQuery("");
                      if (searchInputRef.current)
                        searchInputRef.current.value = "";
                    }}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <XIcon className="h-3.5 w-3.5" />
                  </button>
                )}
              </div>
            </div>
          )}

          <div
            ref={mapRef}
            className="flex-1 min-h-0 w-full"
            style={{ minHeight: 0 }}
          />
          {totalDistance > 0 && (
            <div className="absolute top-3 right-16 z-50 bg-blue-600 text-white rounded-full px-4 py-2 text-sm font-bold shadow-lg">
              🚗 {Number(totalDistance).toFixed(2)} KM
            </div>
          )}

          {/* ✅ Bottom legend: expense context shows only the expense button */}
          {summaryStats &&
            context !== "compare" &&
            context !== "morningPunch" &&
            context !== "eveningPunch" && (
              <div
                style={{
                  position: "absolute",
                  bottom: "12px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 9998,
                  whiteSpace: "nowrap",
                }}
              >
                <div
                  className="flex flex-wrap items-center justify-center gap-1 px-3 py-1.5 rounded-full shadow-lg border border-white/30"
                  style={{
                    background: "rgba(17,24,39,0.72)",
                    backdropFilter: "blur(8px)",
                  }}
                >
                  {context === "expense" ? (
                    // ✅ Expense mode: only show the expense legend button
                    <button
                      onClick={() => focusOnActivity("add_expense_visit")}
                      className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium transition-all hover:scale-105 active:scale-95"
                      style={{
                        background: "#14b8a622",
                        border: "1px solid #14b8a655",
                        color: "#f9fafb",
                      }}
                      title="Focus Expense Visits"
                    >
                      <span>🧾</span>
                      <span>Expense Visit</span>
                    </button>
                  ) : (
                    // ─── All other contexts: original legend buttons unchanged ───
                    <>
                      {[
                        { key: "morning_punch", color: "#10b981", emoji: "🟢", label: "Punch In" },
                        { key: "punch_out", color: "#ef4444", emoji: "🔴", label: "Punch Out" },
                        { key: "doctor", color: "#8b5cf6", emoji: "🏥", label: "Doctor" },
                        { key: "chemist", color: "#ec4899", emoji: "💊", label: "Chemist" },
                        { key: "stockist", color: "#f97316", emoji: "📦", label: "Stockist" },
                        { key: "last_call", color: "#06b6d4", emoji: "📞", label: "Last Call" },
                      ].map(({ key, color, emoji, label }) => (
                        <button
                          key={key}
                          onClick={() => focusOnActivity(key)}
                          className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium transition-all hover:scale-105 active:scale-95"
                          style={{
                            background: `${color}22`,
                            border: `1px solid ${color}55`,
                            color: "#f9fafb",
                          }}
                          title={`Focus ${label}`}
                        >
                          <span>{emoji}</span>
                          <span>{label}</span>
                        </button>
                      ))}
                      <div
                        className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
                        style={{
                          background: "#3b82f622",
                          border: "1px solid #3b82f655",
                          color: "#f9fafb",
                        }}
                      >
                        <svg width="18" height="6" viewBox="0 0 18 6">
                          <line
                            x1="0"
                            y1="3"
                            x2="18"
                            y2="3"
                            // stroke="#3b82f6"
                            stroke="#ef4444"
                            strokeWidth="2.5"
                            strokeDasharray="4 2"
                          />
                        </svg>
                        <span>Route</span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
        </div>

        {/* ─── Linear distance footer (only in punch contexts) — untouched ─── */}
        {(context === "morningPunch" || context === "eveningPunch") &&
          linearDistance && (
            <div className="px-4 py-3 bg-gray-100 border-t-2 border-gray-200 text-sm font-medium text-gray-700 text-center">
              Approximate Linear Distance Between ( {linearDistance.label} ) :{" "}
              <span className="text-blue-700 font-bold">
                {linearDistance.km} KM
              </span>
            </div>
          )}

        {/* Compare mode legend — untouched */}
        {context === "compare" && compareLocations.length > 0 && (
          <div className="px-3 py-3 bg-gradient-to-br from-gray-50 to-blue-50 border-t-2 border-blue-100">
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm bg-white p-3 rounded-lg border-2 border-gray-200 shadow-sm">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded bg-green-600" />
                <span className="text-gray-700 font-medium">
                  Individual (IND) - All Positions
                </span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded bg-blue-600" />
                <span className="text-gray-700 font-medium">
                  Senior (SR) - All Positions
                </span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded bg-red-600" />
                <span className="text-gray-700 font-medium">
                  Junior (JR) - All Positions
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeMapTracker;